var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eNPyBg0c7kl1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 350",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "1062ffbac21840e4a91b9f8bb8cabe68",
    "export-id": "636d6afaf1c9466898e6da62138558e9",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl19-fill",
    x1: -13058.5,
    y1: 1277.01,
    x2: -13053.699,
    y2: 1065.074,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl19-fill-0",
    offset: "17.2%",
    stopColor: "#d7dfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl19-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl20-fill",
    x1: 1774.96,
    y1: 1156.6,
    x2: 1893.643,
    y2: 1156.6,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl20-fill-0",
    offset: "17.2%",
    stopColor: "#d7dfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl20-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl22-fill",
    x1: 2095.36,
    y1: 1509.94,
    x2: 1629.326,
    y2: 1409.151,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl22-fill-0",
    offset: "0%",
    stopColor: "#d7dfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl22-fill-1",
    offset: "100%",
    stopColor: "#e6e4e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl24-fill",
    x1: 1863.56,
    y1: 1335.85,
    x2: 1859.698,
    y2: 1530.489,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl24-fill-0",
    offset: "8.9%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl24-fill-1",
    offset: "100%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl25-fill",
    x1: 1812.99,
    y1: 1334.82,
    x2: 1809.128,
    y2: 1529.459,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl25-fill-0",
    offset: "8.9%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl25-fill-1",
    offset: "100%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl26-fill",
    x1: 1763.5,
    y1: 1333.82,
    x2: 1759.638,
    y2: 1528.459,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl26-fill-0",
    offset: "8.9%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl26-fill-1",
    offset: "100%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl27-fill",
    x1: 1714.36,
    y1: 1332.83,
    x2: 1710.498,
    y2: 1527.469,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl27-fill-0",
    offset: "8.9%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl27-fill-1",
    offset: "100%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl32-fill",
    x1: 1955.62,
    y1: 652.948,
    x2: 1733.165,
    y2: 1090.54,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl32-fill-0",
    offset: "5.2%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl32-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl34-fill",
    x1: 1679.54,
    y1: 1343.35,
    x2: 2028.311,
    y2: 1273.27,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl34-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl34-fill-1",
    offset: "63.7%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl34-fill-2",
    offset: "94.4%",
    stopColor: "#c93d47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl56-fill",
    x1: 2079.59,
    y1: 916.047,
    x2: 2360.49,
    y2: 916.047,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl56-fill-0",
    offset: "5.7%",
    stopColor: "#d9e8e7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl56-fill-1",
    offset: "56.2%",
    stopColor: "#fda47d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl56-fill-2",
    offset: "85.8%",
    stopColor: "#f77451"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl56-fill-3",
    offset: "96%",
    stopColor: "#f77451"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl57-fill",
    x1: 1686.24,
    y1: 888.301,
    x2: 1951.308,
    y2: 888.301,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl57-fill-0",
    offset: "21.6%",
    stopColor: "#ffb8c6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl57-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl64-fill",
    x1: 1970.9,
    y1: 544.731,
    x2: 2367.037,
    y2: 792.494,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl64-fill-0",
    offset: "49%",
    stopColor: "#d9e8e7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl64-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl65-fill",
    x1: 2118.3,
    y1: 720.083,
    x2: 2363.831,
    y2: 720.083,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl65-fill-0",
    offset: "5.2%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl65-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl78-fill",
    x1: 2079.59,
    y1: 916.047,
    x2: 2348.364,
    y2: 916.047,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl78-fill-0",
    offset: "0%",
    stopColor: "#ff915a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl78-fill-1",
    offset: "50.5%",
    stopColor: "#e53e53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl78-fill-2",
    offset: "100%",
    stopColor: "#991159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl89-fill",
    x1: 2100.75,
    y1: 605.278,
    x2: 2224.415,
    y2: 737.188,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl89-fill-0",
    offset: "25.4%",
    stopColor: "#fcb348"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl89-fill-1",
    offset: "91.4%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl91-fill",
    x1: 2423,
    y1: 711.964,
    x2: 2579.02,
    y2: 711.964,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl91-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl91-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl92-fill",
    x1: 2499.65,
    y1: 779.278,
    x2: 2471.454,
    y2: 839.258,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl92-fill-0",
    offset: "37.6%",
    stopColor: "#ea8e67"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl92-fill-1",
    offset: "100%",
    stopColor: "#ffc99f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl93-fill",
    x1: 2508.07,
    y1: 1045.02,
    x2: 2331.692,
    y2: 914.432,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl93-fill-0",
    offset: "0%",
    stopColor: "#d35552"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl93-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl97-fill",
    x1: 2354.43,
    y1: 1515.3,
    x2: 2299.261,
    y2: 1515.3,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl97-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl97-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl98-fill",
    x1: 2290.39,
    y1: 1541.46,
    x2: 2346.265,
    y2: 1563.965,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl98-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl98-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl100-fill",
    x1: 2100.05,
    y1: 1195.81,
    x2: 2081.357,
    y2: 1140.978,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl100-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl100-fill-1",
    offset: "63.7%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl100-fill-2",
    offset: "94.4%",
    stopColor: "#c93d47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl101-fill",
    x1: 2228.08,
    y1: 1091.33,
    x2: 2042.875,
    y2: 1091.33,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl101-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl101-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl102-fill",
    x1: 2352.2,
    y1: 1120.46,
    x2: 2051.349,
    y2: 1072.793,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl102-fill-0",
    offset: "7.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl102-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl106-fill",
    x1: 2136.17,
    y1: 755.782,
    x2: 2510.269,
    y2: 1339.504,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl106-fill-0",
    offset: "21.6%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl106-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl107-fill",
    x1: 2385.53,
    y1: 1887.17,
    x2: 1858.154,
    y2: 1352.521,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl107-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl107-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl107-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl107-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl108-fill",
    x1: 2164.85,
    y1: 1540.61,
    x2: 2278.62,
    y2: 1549.218,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl108-fill-0",
    offset: "21.6%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl108-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl109-fill",
    x1: 2485.1,
    y1: 1590.78,
    x2: 2156.909,
    y2: 1689.422,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl109-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl109-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl109-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl109-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl115-fill",
    x1: 2425.03,
    y1: 1624.21,
    x2: 2227.609,
    y2: 1654.26,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl115-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl115-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl117-fill",
    x1: 2423.66,
    y1: 1549.71,
    x2: 2397.717,
    y2: 1549.71,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl117-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl117-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl118-fill",
    x1: 2423.66,
    y1: 1554.07,
    x2: 2397.717,
    y2: 1554.07,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl118-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl118-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl119-fill",
    x1: 2468.58,
    y1: 1071.91,
    x2: 2639.959,
    y2: 1397.53,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl119-fill-0",
    offset: "21.6%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl119-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl120-fill",
    x1: 2391.38,
    y1: 1532.97,
    x2: 2420.245,
    y2: 1580.86,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl120-fill-0",
    offset: "21.6%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl120-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl121-fill",
    x1: 2426.92,
    y1: 1652.32,
    x2: 2362.784,
    y2: 1592.272,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl121-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl121-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl121-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl121-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl122-fill",
    x1: 2320.59,
    y1: 1819.46,
    x2: 2141.222,
    y2: 1290.064,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl122-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl122-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl122-fill-2",
    offset: "92.2%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl123-fill",
    x1: 2430.89,
    y1: 1633.41,
    x2: 2357.518,
    y2: 1605.032,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl123-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl123-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl124-fill",
    x1: 2119.6,
    y1: 1185.63,
    x2: 2323.27,
    y2: 1296.427,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl124-fill-0",
    offset: "14.4%",
    stopColor: "#ffb3c2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl124-fill-1",
    offset: "82.3%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl127-fill",
    x1: 1998.21,
    y1: 1090.07,
    x2: 2352.459,
    y2: 1553.573,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl127-fill-0",
    offset: "17.2%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl127-fill-1",
    offset: "95.4%",
    stopColor: "#dde8cf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl127-fill-2",
    offset: "100%",
    stopColor: "#ffd6c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl128-fill",
    x1: 2485.14,
    y1: 914.51,
    x2: 2179.238,
    y2: 1664.556,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl128-fill-0",
    offset: "15.8%",
    stopColor: "#056657"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl128-fill-1",
    offset: "48.3%",
    stopColor: "#098464"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl128-fill-2",
    offset: "97.6%",
    stopColor: "#25b292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl130-fill",
    x1: 2514.58,
    y1: 947.544,
    x2: 2547.585,
    y2: 1138.118,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl130-fill-0",
    offset: "12.6%",
    stopColor: "#056657"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl130-fill-1",
    offset: "100%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl131-fill",
    x1: 2239.01,
    y1: 949.836,
    x2: 2251.781,
    y2: 1159.847,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl131-fill-0",
    offset: "15.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl131-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl132-fill",
    x1: 2323.98,
    y1: 1046.88,
    x2: 2331.014,
    y2: 950.743,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl132-fill-0",
    offset: "0%",
    stopColor: "#7bcfba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl132-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl133-fill",
    x1: 2049.87,
    y1: 1149.94,
    x2: 2130.244,
    y2: 1276.983,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl133-fill-0",
    offset: "13.8%",
    stopColor: "#fff0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl133-fill-1",
    offset: "88.8%",
    stopColor: "#1fb090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl134-fill",
    x1: 2649.21,
    y1: 1741.61,
    x2: 1678.906,
    y2: 908.718,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl134-fill-0",
    offset: "15.8%",
    stopColor: "#056657"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl134-fill-1",
    offset: "48.3%",
    stopColor: "#098464"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl134-fill-2",
    offset: "97.6%",
    stopColor: "#25b292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl135-fill",
    x1: 2492.33,
    y1: 1137.93,
    x2: 2021.131,
    y2: 1430.8,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl135-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl135-fill-1",
    offset: "19.5%",
    stopColor: "#056657"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl135-fill-2",
    offset: "48.3%",
    stopColor: "#098464"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl135-fill-3",
    offset: "97.6%",
    stopColor: "#25b292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl137-fill",
    x1: 2444.21,
    y1: 940.232,
    x2: 2602.138,
    y2: 922.318,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl137-fill-0",
    offset: "13.1%",
    stopColor: "#f05960"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl137-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl138-fill",
    x1: 2705.53,
    y1: 900.17,
    x2: 2501.247,
    y2: 979.247,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl138-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl138-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl139-fill",
    x1: 2445.17,
    y1: 935.867,
    x2: 2525.661,
    y2: 994.566,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl139-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl139-fill-1",
    offset: "92.1%",
    stopColor: "#f05960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl142-fill",
    x1: 2549.91,
    y1: 799.153,
    x2: 2471.413,
    y2: 856.482,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl142-fill-0",
    offset: "11.4%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl142-fill-1",
    offset: "61%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl144-fill",
    x1: 2519.7,
    y1: 797.821,
    x2: 2481.869,
    y2: 766.012,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl144-fill-0",
    offset: "1.9%",
    stopColor: "#d65764"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl144-fill-1",
    offset: "63%",
    stopColor: "#ffc6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl146-fill",
    x1: 2453.51,
    y1: 762.7,
    x2: 2435.468,
    y2: 779.783,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl146-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl146-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl148-fill",
    x1: 2501.69,
    y1: 672.705,
    x2: 2426.7,
    y2: 672.705,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl148-fill-0",
    offset: "5.6%",
    stopColor: "#ffddc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl148-fill-1",
    offset: "77.1%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl150-fill",
    x1: 2423.97,
    y1: 788.69,
    x2: 2434.391,
    y2: 788.69,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl150-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl150-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl154-fill",
    x1: 2484.24,
    y1: 1616.9,
    x2: 2338.148,
    y2: 1607.812,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl154-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl154-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl155-fill",
    x1: 2383.86,
    y1: 1964.53,
    x2: 2345.564,
    y2: 956.88,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl155-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl155-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl156-fill",
    x1: 3316.8,
    y1: 1800.11,
    x2: 1935.32,
    y2: 402.42,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl156-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl156-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl160-fill",
    x1: 2371.97,
    y1: 1668,
    x2: 2345.356,
    y2: 1517.054,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl160-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl160-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl161-fill",
    x1: 2410.91,
    y1: 1660.01,
    x2: 2384.296,
    y2: 1509.064,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl161-fill-0",
    offset: "16.3%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl161-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl162-fill",
    x1: 2449.02,
    y1: 1652.19,
    x2: 2422.406,
    y2: 1501.244,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl162-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl162-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl164-fill",
    x1: 2374.98,
    y1: 1691.22,
    x2: 2361.53,
    y2: 1622.108,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl164-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl164-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl165-fill",
    x1: 2413.54,
    y1: 1682.09,
    x2: 2400.09,
    y2: 1612.978,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl165-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl165-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eNPyBg0c7kl166-fill",
    x1: 2451.29,
    y1: 1673.15,
    x2: 2437.84,
    y2: 1604.038,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl166-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eNPyBg0c7kl166-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.420369 0 0 0.4053 135.704806-26.359691)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.617736 0 0 0.670536-1183.673373-274.171761)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "eNPyBg0c7kl12",
    d: "M1084.3,667.9l-19.7,11.4-19.8,11.4c-2.4,1.4-3.6,3.9-3.6,6.3c0,2.5,1.2,4.9,3.6,6.3l19.8,11.4l19.7,11.4c2.5,1.4,5.2,1.2,7.3,0s3.7-3.5,3.7-6.3c0,0,0-15.96,0-22.8s0-22.8,0-22.8c0-2.8-1.6-5.1-3.7-6.3s-4.8-1.4-7.3,0Z",
    transform: "matrix(-.171832 0.985126-.985126-.171832 2337.950201-282.311935)",
    fill: "#55c0a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eNPyBg0c7kl13",
    d: "M2066.3,362.3l-15.2-17-15.3-16.9c-1.8-2.1-4.5-2.8-6.9-2.3s-4.5,2.2-5.4,4.9l-7.1,21.6-7.1,21.7c-.9,2.6-.1,5.3,1.5,7.1s4.2,2.9,6.9,2.3L2040,379l22.3-4.7c2.8-.6,4.7-2.5,5.5-4.9.7-2.3.3-5-1.5-7.1Z",
    transform: "matrix(-.723007-.69084 0.69084-.723007 2903.250664 2831.993232)",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eNPyBg0c7kl15",
    d: "M1834.2,560.2l20.2-10.4l20.3-10.5c2.5-1.3,3.8-3.7,3.9-6.1.1-2.5-1-5-3.3-6.5l-19.2-12.3-19.2-12.3c-2.3-1.5-5.1-1.5-7.3-.4-2.1,1.2-3.8,3.4-3.9,6.2l-1.1,22.7-1,22.8c-.2,2.8,1.2,5.2,3.3,6.5s4.8,1.6,7.3.3Z",
    transform: "matrix(.782295 0.622908-.622908 0.782295 406.085661 119.273553)",
    fill: "#f88e6d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.145448 0 0 1.166862-307.810546-192.393994)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-.000012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2541.1,1159.8h-371.7-371.8v-3.5-3.6h371.8h371.7v3.6v3.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1936.3,1617.2h-3.5-3.6v-230.6-230.7h3.6h3.5v230.7v230.6Z",
    fill: "url(#eNPyBg0c7kl19-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.2,1414.2h-1.1-1.1v-36.2-36.3h58.2h58.2v-92.6-92.5h1.1h1.1v93.6v93.7h-58.2-58.2v35.2v35.1Z",
    fill: "url(#eNPyBg0c7kl20-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1668.4,1386.2h104.3h104.2c1.8,0,3.5.8,4.7,2s1.9,2.8,1.9,4.7v19.6v19.7c0,1.8-.7,3.5-1.9,4.7s-2.9,1.9-4.7,1.9h-104.2-104.3c-1.8,0-3.5-.7-4.7-1.9s-1.9-2.9-1.9-4.7v-19.7-19.6c0-1.9.7-3.5,1.9-4.7s2.9-2,4.7-2Z",
    fill: "url(#eNPyBg0c7kl22-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1834.6,1414.2c0,3.8,1.6,7.2,4,9.6c2.5,2.5,5.8,4,9.6,4c3.7,0,7.1-1.5,9.6-4c2.4-2.4,3.9-5.8,3.9-9.6c0-3.7-1.5-7.1-3.9-9.6-2.5-2.4-5.9-3.9-9.6-3.9-3.8,0-7.1,1.5-9.6,3.9-2.4,2.5-4,5.9-4,9.6Z",
    fill: "url(#eNPyBg0c7kl24-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784,1414.2c0,3.8,1.6,7.2,4,9.6c2.5,2.5,5.8,4,9.6,4c3.7,0,7.1-1.5,9.6-4c2.4-2.4,3.9-5.8,3.9-9.6c0-3.7-1.5-7.1-3.9-9.6-2.5-2.4-5.9-3.9-9.6-3.9-3.8,0-7.1,1.5-9.6,3.9-2.4,2.5-4,5.9-4,9.6Z",
    fill: "url(#eNPyBg0c7kl25-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734.5,1414.2c0,3.8,1.5,7.2,4,9.6c2.4,2.5,5.8,4,9.6,4c3.7,0,7.1-1.5,9.6-4c2.4-2.4,3.9-5.8,3.9-9.6c0-3.7-1.5-7.1-3.9-9.6-2.5-2.4-5.9-3.9-9.6-3.9-3.8,0-7.2,1.5-9.6,3.9-2.5,2.5-4,5.9-4,9.6Z",
    fill: "url(#eNPyBg0c7kl26-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685.4,1414.2c0,3.8,1.5,7.2,3.9,9.6c2.5,2.5,5.9,4,9.6,4c3.8,0,7.2-1.5,9.6-4c2.5-2.4,4-5.8,4-9.6c0-3.7-1.5-7.1-4-9.6-2.4-2.4-5.8-3.9-9.6-3.9-3.7,0-7.1,1.5-9.6,3.9-2.4,2.5-3.9,5.9-3.9,9.6Z",
    fill: "url(#eNPyBg0c7kl27-fill)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-.000049)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2004.7,1081.4v36.5v36.6h4.8h4.7v-36.6-36.5h-4.7-4.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2150.1,795.5l13,142.9l13,143h-157.7-157.8l-13.7-143.8-13.7-143.9l158.4.9l158.5.9Z",
    fill: "url(#eNPyBg0c7kl32-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.3,815.6l.6,6.3.7,6.3l11,103.7l11.1,103.6c.3,3,1.8,5.6,3.9,7.5c2.2,1.9,5.1,3,8.3,3h136.5h136.5c3.6,0,6.8-1.5,9.1-3.8c2.2-2.3,3.4-5.5,3.1-9l-10.4-102.5-10.5-102.5-.7-6.9-.7-6.9c-.3-2.8-1.8-5.4-3.9-7.2s-5-2.9-8-3l-137.3-.7-137.2-.7c-3.6,0-6.8,1.5-9.1,3.8-2.2,2.4-3.4,5.6-3,9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860.6,1081.4l-5.7,2-5.7,2.1-13.3-139.8-13.2-139.8l5.2-6.1l5.3-6.1l13.7,143.9l13.7,143.8Z",
    fill: "url(#eNPyBg0c7kl34-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.3,816l.6,6.4.7,6.5h149.3h149.3l-.7-7.1-.7-7c-.3-3-1.8-5.6-3.9-7.5-2.1-1.8-5-3-8-3.1l-137.3-.7-137.2-.7c-3.6,0-6.8,1.5-9.1,3.9-2.2,2.5-3.4,5.7-3,9.3Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882.4,1065.5c0-1.6.7-3,1.7-4s2.4-1.6,3.9-1.6c1.6,0,3,.6,4,1.6s1.6,2.4,1.6,4c0,1.5-.6,2.9-1.6,3.9-1,1.1-2.4,1.7-4,1.7-1.5,0-2.9-.6-3.9-1.7-1-1-1.7-2.4-1.7-3.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1846.5,807q1.5-1.3,3.5-2t4.3-.8l137.6.7l137.6.7c3,.1,5.9,1.2,8,3s3.6,4.4,3.9,7.3l.8,6.9.7,6.9l10.4,102.8l10.4,102.9c.2,1.5,0,2.9-.4,4.3-.4,1.3-1,2.6-1.9,3.7c1.5-1.2,2.7-2.7,3.5-4.5.8-1.7,1.1-3.7.9-5.7l-10.4-102.8L2145,827.5l-.7-6.9-.7-6.9c-.4-2.9-1.9-5.4-4-7.2-2.1-1.9-5-3-8-3.1l-137.6-.7-137.6-.7c-2,0-4,.5-5.7,1.4s-3.2,2.1-4.2,3.6Z",
    fill: "#db7519"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2027.3,862.5h-70.1-70.1l-.5-3.9-.4-4h70.1h70.2l.4,4l.4,3.9Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2029.3,880.1h-70.1-70.2l-.4-4-.4-4h70.1h70.1l.5,4l.4,4Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2031.6,900.1h-70.2-70.1l-.5-4-.4-3.9h70.2h70.1l.5,3.9.4,4Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2033.6,917.7h-70.2-70.2l-.4-4-.4-3.9h70.1h70.2l.5,3.9.4,4Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2036,939.1h-70.2-70.2l-.4-3.9-.4-4h70.2h70.2l.4,4l.4,3.9Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2038.1,956.6h-70.3-70.2l-.4-3.9-.5-4h70.2h70.2l.5,4l.5,3.9Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040.3,976.6h-70.2-70.3l-.4-4-.4-4h70.2h70.3l.4,4l.4,4Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2042.3,994.1h-70.2-70.3l-.4-4-.5-3.9h70.3h70.2l.5,3.9.4,4Z",
    fill: "#ccc4cc"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2108.4,816.6c0,.9-.3,1.7-.9,2.3s-1.5.9-2.4.9-1.7-.3-2.3-.9-1-1.4-1-2.3.4-1.7,1-2.3s1.4-.9,2.3-.9s1.8.3,2.4.9.9,1.4.9,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2120.3,816.6c0,.9-.3,1.7-.9,2.3s-1.5.9-2.4.9-1.7-.3-2.3-.9-1-1.4-1-2.3.4-1.7,1-2.3s1.4-.9,2.3-.9s1.8.3,2.4.9.9,1.4.9,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132,816.6c0,.9-.4,1.7-1,2.3s-1.4.9-2.3.9-1.8-.3-2.4-.9-.9-1.4-.9-2.3.3-1.7.9-2.3s1.5-.9,2.4-.9s1.7.3,2.3.9s1,1.4,1,2.3Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2004.1,1081.4l.3,14.8.3,14.8q2.2,1.8,4.6,3.5t4.9,3.2l.4-18.2.4-18.1h-5.4-5.5Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2176.1,1081.4h-157.7-157.8l-5.7,2-5.7,2.1h160.2h160.3l3.2-2.1l3.2-2Z",
    fill: "#991159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2047.1,1159.9h-37.5-37.6c0-3,4.2-5.6,11-7.5s16.2-3,26.6-3c10.3,0,19.7,1.1,26.5,3s11,4.5,11,7.5Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "eNPyBg0c7kl56",
    d: "M2349.5,1056h-123.8-123.8c-2.8,0-5.4-1-7.4-2.8-1.9-1.8-3.2-4.3-3.5-7.2l-5.2-54.2-5.2-54.2v-.1l-.5-4.7-.5-4.6c-.3-3.3.8-6.3,2.8-8.5c2-2.3,4.9-3.7,8.2-3.7h122.8h122.8c2.8,0,5.3,1.1,7.3,2.8c1.9,1.8,3.2,4.2,3.5,7l.7,5.9.7,5.9l6,53.1l6,53.1c.4,3.2-.7,6.3-2.7,8.6-2,2.2-4.9,3.6-8.2,3.6Z",
    opacity: 0.9,
    fill: "url(#eNPyBg0c7kl56-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eNPyBg0c7kl57",
    d: "M1697.3,888.3h117.9h118c2.8,0,5.4,1.1,7.3,2.8c2,1.8,3.3,4.3,3.6,7.1l3.6,34l3.6,34c.3,3.3-.8,6.3-2.8,8.6-2,2.2-4.9,3.6-8.2,3.6h-118.1-118.1c-2.9,0-5.5-1.1-7.4-2.8-2-1.8-3.3-4.3-3.6-7.1l-3.4-34-3.4-34.1c-.3-3.2.8-6.3,2.8-8.5s4.9-3.6,8.2-3.6Z",
    opacity: 0.9,
    fill: "url(#eNPyBg0c7kl57-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eNPyBg0c7kl58",
    d: "M1766.8,928.6c.5.7.8,1.6.9,2.4c0,.9-.1,1.8-.5,2.6s-1,1.5-1.7,2q-.6.4-1.2.7-.5.3-1.2.5-.4.1-.7.3-.4.1-.7.3c-.6.2-1.3.6-1.9,1.2-.6.5-1.1,1.2-1.2,2.2-.1.7,0,1.4.2,2c.3.6.6,1.2.9,1.8l.1.2.1.2c.7,1.2,1.2,2.6,1.3,4.1.1,1.4-.2,2.8-1.1,3.9-1.1,1.2-2.6,1.6-4.1,1.5-1.6-.1-3.3-.6-4.6-1.5l-.1-.1-.2-.1q-.4-.3-.9-.6-.5-.2-1.1-.3c-1.1-.3-2.2.2-3,.9-.9.8-1.5,1.8-1.9,3q-.1.4-.2.8-.2.5-.3.9c-.1.7-.3,1.4-.5,2-.3.7-.6,1.3-1,1.8-.7.7-1.6,1.2-2.6,1.4-1.1.2-2.2.1-3.2-.3-.9-.4-1.8-1-2.5-1.8s-1.3-1.8-1.8-2.9q-.1-.2-.2-.5-.1-.2-.1-.5c-.3-.8-.6-1.6-1-2.3-.5-.8-1-1.4-1.8-1.8q-.4-.2-.9-.3-.4-.1-.8,0c-.6,0-1.2.1-1.8.2-.6.2-1.1.4-1.7.6l-.2.1-.2.1q-1.4.5-2.6.7-1.1.1-2.1-.1c-.7-.1-1.4-.5-1.9-1-.6-.5-1-1.2-1.1-1.9q0-.6.1-1.3.2-.6.4-1.2l.8-2.2.7-2.2c.4-.9.6-1.9.7-2.8c0-.9-.1-1.8-.7-2.6-.5-.7-1.1-1.1-1.9-1.3-.7-.3-1.5-.4-2.3-.5q-.6-.1-1.1-.2t-1-.2c-.9-.3-1.7-.9-2.3-1.6-.7-.8-1.1-1.7-1.3-2.6-.1-1,0-2,.4-2.9s1-1.7,1.8-2.2q.6-.4,1.3-.7t1.5-.6q.4-.1.8-.2.4-.2.8-.3c.4-.2,1.3-.6,2-1.3.7-.6,1.3-1.4,1.4-2.6.1-.7-.1-1.4-.4-2-.2-.6-.6-1.2-1-1.7q-.3-.5-.6-.9-.2-.5-.4-1-.4-.8-.3-1.7q0-1,.5-1.9c.3-.7.7-1.3,1.3-1.8.5-.5,1.1-.9,1.8-1.2c1.4-.5,2.7-.4,3.8,0c1.2.3,2.1.9,2.8,1.3q.1.1.3.3.1.1.3.2.6.5,1.2.9t1.3.5q.8.1,1.5-.3.8-.4,1.5-1.3.6-.8.9-1.7.4-.9.6-1.9.1-.4.2-.8.2-.4.3-.7c.4-1.1.9-2,1.6-2.7.6-.7,1.3-1.3,2.2-1.7s1.9-.4,2.8-.3c.9.2,1.7.7,2.3,1.3.4.5.6,1.1.8,1.7s.4,1.2.5,1.9c.2.9.4,1.7.7,2.5.4.8.8,1.5,1.5,2c1,.8,2.1.9,3.2.8c1.2,0,2.4-.4,3.5-.7c1.1-.4,2.2-.7,3.2-.8s1.9.1,2.6.7c.7.5,1.1,1.4,1.2,2.3s0,1.8-.2,2.7q-.1.5-.3,1t-.4,1q-.3.9-.5,1.8-.3,1-.4,1.9q0,.7,0,1.2.1.6.3,1c.4.9,1.1,1.4,1.8,1.8.8.4,1.7.7,2.6.9q.6.1,1.2.3t1.2.4c.8.4,1.5,1,2,1.8Zm-17.5,13.7c2.7-2.7,4.3-6.3,4.3-10.4c0-4-1.6-7.7-4.3-10.3-2.6-2.7-6.3-4.3-10.3-4.3-4.1,0-7.7,1.6-10.4,4.3-2.6,2.6-4.3,6.3-4.3,10.3c0,4.1,1.7,7.7,4.3,10.4c2.7,2.7,6.3,4.3,10.4,4.3c4,0,7.7-1.6,10.3-4.3Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eNPyBg0c7kl64",
    d: "M2357.1,783.5h-111.9-111.9c-2.9,0-5.5-1.1-7.4-2.8-2-1.8-3.3-4.3-3.6-7.1l-1.7-17.8-1.7-17.7-.3-3-.3-3c-.3-3.2.8-6.2,2.8-8.4s4.9-3.6,8.2-3.6h111.2h111.3c2.7,0,5.3,1,7.2,2.7c2,1.7,3.4,4.1,3.7,6.8l.6,4.3.5,4.2l2.1,16.5l2.1,16.5c.5,3.3-.6,6.4-2.6,8.7s-5,3.7-8.3,3.7Z",
    fill: "url(#eNPyBg0c7kl64-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eNPyBg0c7kl65",
    d: "M2363.8,738.1h-122.4-122.5l-.3-3-.3-3c-.3-3.2.8-6.2,2.8-8.4s4.9-3.6,8.2-3.6h111.2h111.3c2.7,0,5.3,1,7.2,2.7c2,1.7,3.4,4.1,3.7,6.8l.6,4.3.5,4.2Z",
    fill: "url(#eNPyBg0c7kl65-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eNPyBg0c7kl66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1927,915.8h-72.5-72.4l-.4-2.7-.3-2.8h72.5h72.5l.3,2.8.3,2.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828.9,931.9h-22.4-22.5l-.3-2.7-.4-2.8h22.6h22.6l.2,2.8.2,2.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1929.4,946.7h-72.4-72.5l-.3-2.8-.4-2.7h72.6h72.5l.2,2.7.3,2.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1831.3,962.8h-22.4-22.5l-.3-2.8-.3-2.7h22.6h22.6l.2,2.7.1,2.8Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eNPyBg0c7kl72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2274.6,1002.9h-72.5-72.4l-.3-2.8-.4-2.7h72.5h72.6l.2,2.7.3,2.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2176.5,1019h-22.4-22.5l-.3-2.8-.3-2.7h22.6h22.5l.2,2.7.2,2.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2272.2,972.1h-72.5-72.4l-.4-2.8-.3-2.7h72.5h72.5l.3,2.7.3,2.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2174.1,988.2h-22.5-22.4l-.3-2.8-.4-2.8h22.6h22.6l.2,2.8.2,2.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080.6,937.6v-.1l-.5-4.7-.5-4.6c-.3-3.3.8-6.3,2.8-8.5c2-2.3,4.9-3.7,8.2-3.7h122.8h122.8c2.8,0,5.3,1.1,7.3,2.8c1.9,1.8,3.2,4.2,3.5,7l.7,5.9.7,5.9h-133.9-133.9Z",
    fill: "url(#eNPyBg0c7kl78-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2309.4,926.8c0,.9-.3,1.7-.9,2.3s-1.5.9-2.4.9-1.7-.3-2.3-.9-1-1.4-1-2.3.4-1.7,1-2.3s1.4-.9,2.3-.9s1.8.3,2.4.9.9,1.4.9,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2321.3,926.8c0,.9-.3,1.7-.9,2.3s-1.5.9-2.4.9-1.7-.3-2.3-.9-1-1.4-1-2.3.4-1.7,1-2.3s1.4-.9,2.3-.9s1.8.3,2.4.9.9,1.4.9,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2333,926.8c0,.9-.4,1.7-1,2.3s-1.4.9-2.3.9-1.8-.3-2.4-.9-.9-1.4-.9-2.3.3-1.7.9-2.3s1.5-.9,2.4-.9s1.7.3,2.3.9s1,1.4,1,2.3Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eNPyBg0c7kl83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2303.6,755.9h-75.5-75.5l-.3-2.8-.4-2.7h75.6h75.6l.3,2.7.2,2.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2305,772h-75.2-75.2l-.3-2.8-.4-2.7h75.2h75.2l.4,2.7.3,2.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2156.7,724.8c-3.1,8.4-9.2,14.6-16.7,18.1-7.5,3.4-16.3,4-24.6.9s-14.6-9.3-18-16.7c-3.4-7.5-4-16.3-.9-24.6s9.2-14.6,16.7-18s16.2-4,24.6-.9c8.3,3.1,14.5,9.2,18,16.7c3.4,7.4,4,16.2.9,24.5Z",
    fill: "#1fb090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2123.9,732.1q-.9,0-1.7-.4t-1.4-1.2l-6.4-8.3-6.4-8.4l3.1-2.4l3.1-2.3l4.6,6l4.6,5.9l7.3-13.5l7.4-13.5l3.4,1.9l3.4,1.8-8.8,16.2-8.8,16.1q-.5.9-1.3,1.4-.8.6-1.8.7-.1,0-.2,0q0,0-.1,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2126.6,752.8c-10.8,0-20.6-4.4-27.6-11.5-7.1-7.1-11.5-16.8-11.5-27.6s4.4-20.6,11.5-27.7c7-7.1,16.8-11.4,27.6-11.4s20.6,4.3,27.6,11.4c7.1,7.1,11.5,16.9,11.5,27.7s-4.4,20.5-11.5,27.6c-7,7.1-16.8,11.5-27.6,11.5Zm0-77.1c-10.5,0-20,4.2-26.9,11.1s-11.1,16.4-11.1,26.9s4.2,20,11.1,26.8c6.9,6.9,16.4,11.2,26.9,11.2s20-4.3,26.9-11.2c6.8-6.8,11.1-16.3,11.1-26.8s-4.3-20-11.1-26.9c-6.9-6.9-16.4-11.1-26.9-11.1Z",
    fill: "url(#eNPyBg0c7kl89-fill)",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.007971 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2558.8,841.6c-1.4,16-1.4,32.2.2,48.2c1.7,15.9,5.1,31.7,10.7,46.8.3.7.6,1.5.7,2.3s0,1.6-.5,2.3q-.4.5-.9.8t-1.1.6q-11.2,5.3-22.8,9.4-11.7,4.2-23.7,7c-6.2,1.4-12.6,2.6-18.9,3.1-6.4.5-12.8.4-19-.8-2.8-.5-5.5-1.2-8.2-2.1s-5.3-2.1-7.8-3.5q-.7-.3-1.3-.7-.7-.4-1.3-.8c-1.3-.9-2.6-1.9-3.8-2.9-1.2-1.1-2.2-2.4-3.1-3.8-.5-.9-1.5-2.7-2.2-4.4s-1.2-3.5-1-4.5q0-.5.2-1q.2-.4.5-.8c2.3-4.3,4.3-7.5,6-10.2s3.2-5,4.5-7.5q1.4-2.6,2.5-4.7q1-2.1,1.8-3.7c.7-1.6,1.3-2.9,1.8-4.2.6-1.2,1-2.4,1.5-3.7q0-.1.1-.2q0-.1,0-.2c1.5-3.9,2.4-8.4,2.9-11.8.6-3.5.8-6,.9-6-3.8,0-8.4-.6-13-1.5s-9.1-2.1-12.8-3.4q-.3-.1-.7-.2t-.7-.2q-1.6-.7-2.9-1.3t-2.1-1.2c-1.8-1.3-3.1-3.2-4.1-5.2-1.1-2.1-1.9-4.3-2.7-6.4q-1.6-3.6-3-7.1-1.4-3.6-2.6-7.2-.2-.3-.3-.7-.1-.3-.2-.6c-2-5.7-3.8-11.5-5.3-17.4-1.4-5.9-2.6-11.9-3.3-18.1-.2-.9-.1-1.7,0-2.4s.3-1.4.7-2.1q.2-.5.5-1.1t.5-1.3c1.8-4.2,2.8-8.8,3-13.3.2-4.6-.5-9.2-1.9-13.6q-.6-1.6-1.2-3.2t-1.2-3.2q0-.3-.1-.5t-.2-.5q-.3-1-.5-2-.2-1.1-.3-2.2-.1-.5-.1-1.1q0-.5.1-1.1q0-.9.1-1.9t.3-1.9c1.2-5.1,3.1-9.9,5.4-14.4c2.4-4.5,5.3-8.7,8.5-12.7v-.1q2-2.6,4.2-5q2.1-2.5,4.4-4.8c2.5-2.6,5-4.9,7.8-6.7c2.7-1.8,5.8-3.1,9.4-3.7c1.6-.3,3.2-.8,4.8-1.1s3.2-.6,5-.6c1.9-.1,3.9,0,5.8.1s3.9.2,5.8.1q3.3-.2,6.7-.5q3.3-.3,6.6-.6q3.3-.4,6.7-.6q3.3-.2,6.7-.1c11.6.3,23.6,2,34.7,5.7s21.3,9.3,29.6,17.6c.6.6,1.3,1.3,1.8,2c.6.7,1,1.5,1.3,2.4.4,1.2.4,2.5.2,3.8-.1,1.3-.5,2.6-.8,3.9-4,13.6-7.7,27.4-10.8,41.2-3.2,13.9-5.7,27.9-7.4,41.9q-.3,2.8-.6,5.6-.3,2.7-.5,5.5Z",
    fill: "url(#eNPyBg0c7kl91-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440.2,790.2c-1.2,3.3-2.8,6.4-4.9,9.3-2.1,2.8-4.5,5.4-7.3,7.6q-.7.5-1.6,1.2t-1.9,1.3q.2-.5.5-1.1t.5-1.3c1.8-4.2,2.8-8.8,3-13.3.2-4.6-.5-9.2-1.9-13.6q-.6-1.6-1.2-3.2t-1.2-3.2q0-.3-.1-.5t-.2-.5q-.3-1-.5-2-.2-1.1-.3-2.2-.1-.5-.1-1.1q0-.5.1-1.1.2-.2.4-.4.3-.1.5-.2c2.8-1.5,6-1.4,9-.2c2.9,1.1,5.5,3.4,6.9,6.2c1.5,2.7,2.2,5.8,2.1,9c0,3.1-.7,6.3-1.8,9.3Z",
    opacity: 0.6,
    fill: "url(#eNPyBg0c7kl92-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2569.9,941.2q-.2.2-.4.4-.1.2-.4.3c-4.3,3-9,5.3-13.9,7.3-4.9,1.9-9.9,3.5-15,4.9-7.8,2.1-15.8,4.4-23.9,6-8,1.6-16.2,2.6-24.4,2.2-4.6,0-9.4-1.4-13.8-3.6-4.5-2.2-8.6-5.1-11.9-8.1-1.2-1.2-3.2-3.9-4.7-6.9-1.6-2.9-2.8-6.1-2.7-8c0,0,2.3.4,5.4.7c3.2.3,7.1.4,10.4-.1c8-1.4,12.1-5.1,14.7-9.8c2.5-4.8,3.5-10.7,5.3-16.6c1.5-5.1,2.8-10.3,3.9-14.9s2-8.7,2.8-11.7c.4-1.8,1.2-5.4,1.9-8.6s1.3-5.9,1.3-5.9c-2.2,2.3-3.5,3.5-5.4,4.7-1.9,1.3-4.4,2.6-9,5.3-2.9,1.7-6,3.1-8.5,4.1-2.4,1.1-4.1,1.7-4.1,1.7s-.9-.1-2.1-.1c-1.3-.1-2.9-.2-4.5-.4q-4.9-.6-9.7-1.7-4.8-1-9.5-2.7c5.1-.5,11.7-2.5,18.3-5s13.2-5.4,18.4-7.9c.9-.5,1.6-1.1,2.1-2c.5-.8.8-1.8.7-2.8-.4-7.2-1.2-14-2.4-20.8s-2.8-13.5-4.7-20.6q-.7-2.7-1.5-5.5-.9-2.8-1.8-5.7-.1-.5-.2-.9-.2-.5-.3-1c-.5-1.4-.2-2.9.4-4.1.7-1.2,1.9-2,3.4-2.3q4-.8,8-1.6t8.2-1.6c.7-.2,1.5-.3,2.2-.4.8-.1,1.5-.1,2.3.1q1.1.3,2.1,1t1.8,1.5q.2.2.4.3.1.2.2.4c2.5,2.7,4.4,5.8,5.9,9.1s2.5,6.9,3.2,10.5c.7,3.4,1,6.8,1.2,10.3.2,3.4.2,6.9.2,10.3q-.1.9-.2,1.9q0,.9-.1,1.8q1.3-.9,2.7-1.7t2.8-1.6q6.1-3.1,12.6-5.5q6.4-2.4,13.2-3.9q2.2-.5,4.5-.9q2.3-.3,4.6-.6-.3,2.8-.6,5.6-.3,2.7-.5,5.5c-1.4,16-1.4,32.2.2,48.2c1.7,15.9,5.1,31.7,10.7,46.8.3.7.6,1.5.7,2.3s0,1.6-.5,2.3Z",
    fill: "url(#eNPyBg0c7kl93-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2518.2,820.3c-.3.5-.9.9-1.5,1.2-.7.2-1.4.5-2.4.8-2.1.7-4.3,1.1-6.5,1.3-2.1.3-4.4.5-6.5.6-2,0-3.9.1-5.9,0-1.9-.1-3.9-.4-5.7-.9q-1.4-.3-2.8-1-1.5-.7-2.8-1.7-.7-2.7-1.5-5.5-.9-2.8-1.8-5.7c1.6-2.3,3.9-4,6.5-5.4c2.5-1.5,5.2-2.5,7.7-3.5q4.5-1.8,9.1-3.2q4.7-1.4,9.4-2.3c.9-.2,2.1,3.2,3.1,6.8c1,3.7,1.8,7.5,1.9,8.3q.3,1.9.4,4q.2,2,0,4-.1.7-.2,1.2-.2.6-.5,1Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2555.8,861.2c.2,0,.6-.1,1-.1s.8,0,1,0c0,0,.3-2.8.7-5.9.4-3.2.8-6.6,1-8q.6-4.7,1.3-9.4.8-4.7,1.6-9.4c.9-5,1.8-9.2,2.7-13.4c1-4.3,2-8.5,3-13.4q1.6-7.5,3.5-14.9t4.1-14.7c1.7-5.9,3.4-12.2,5.5-18.3c2.1-6,4.7-11.9,8.3-17q1.9-2.9,4.3-5.3q2.4-2.5,5.2-4.4c.7-.5,3.3-2.2,5.9-3.6s5.2-2.4,6-1.5c-3.8-4.4-9.5-8-15.5-9.9-5.9-2-12.3-2.3-17.7,0c4.8-4.4,8.7-8.4,13.5-11.8c4.7-3.5,10.4-6.3,18.8-8.4-7.6-3.9-15.4-4.6-23-3.1-7.5,1.5-15,5.1-21.9,9.6c0,0-.5-.2-1.3-.8s-2-1.4-3.4-2.7q-1.9-1.7-4-3.2-2-1.5-4.1-2.9-4.3-3-8.8-5.6t-9.2-4.8c-6.1-2.9-12.6-5.4-19.1-7.2-6.6-1.9-13.4-3.3-20.2-4-14-1.6-28.3-.7-42,2.5-13.8,3.2-27,8.6-38.9,16.2c6.2,3.2,12.1,6.8,17.7,10.8c5.7,4.1,11,8.5,16,13.4-8.6,2.4-17.5,5.1-25.4,9.2-7.9,4-14.9,9.3-19.5,16.8q9-4,18.4-7.1t19.1-5.2c3.3-.7,6.9-1.3,10.3-1.1c3.4.1,6.6,1,9.3,3.1q-.7,4.3-2,8.5-1.2,4.2-2.9,8.3c0-.1,2,.4,4.1,1s4.3,1.2,4.7,1.3c1.8.5,3.2.6,4,1.1s1,1.4.8,3.4q-.7,4.7-1.3,9.3-.6,4.7-1.1,9.4c-.6,6.4-1.1,13.5-1,20.5s1,14,3.2,20.2c1.8-.6,4.9-1.4,7.6-2.5c2.8-1.1,5.2-2.4,5.7-3.7.5-1.1.6-2.6.7-4.1c0-1.6.1-3.1.5-4.4q.6-2.2,1.7-4.3q1-2.1,2.4-4c1.8-2.3,4.2-4.4,6.8-5.6s5.5-1.6,8.2-.5c2.5,1,4.2,2.8,5.5,5.1c1.3,2.2,2.2,4.9,2.9,7.4c1.5,5.8,2.8,12.2,3.7,18.6.9,6.5,1.5,13,1.6,19c.1,3.8.1,7,0,10.3c0,3.2-.2,6.5-.3,10.4-.1,1.9-.3,4.3-.4,6.3-.2,1.9-.4,3.4-.4,3.4q1.3.5,2.7.9q1.3.3,2.7.5c5.9,1.1,11.9,1.6,17.9,1.5s11.9-.7,17.8-1.8Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2299.3,1532.1c-.1,1.4.2,2.9.8,4.3.7,1.3,1.6,2.6,2.6,3.7c1.7,1.8,3.6,3.4,5.6,5s4.1,3.1,6.1,4.7q.5.3,1,.7.4.4.9.8q3.7,3.3,7.6,6.4q3.8,3.1,7.8,6.1c2.9,2.1,6.5,5.4,10.2,7.1s7.4,1.9,10.5-2.2c.5-.6.9-1.2,1.3-1.8.3-.7.6-1.3.7-2c.1-1-.1-1.9-.4-2.7-.4-.9-.9-1.7-1.4-2.5q-2-3.4-4-6.9-1.9-3.5-3.6-7.1c-1.1-2.3-2.5-4.5-3.8-6.8-1.3-2.4-2.5-4.7-3.4-7.1-.9-2.3-1.7-4.5-2.8-6.4-1-2-2.3-3.8-4.2-5.2q-1.7-1.4-3.8-2.5-2-1.1-4.4-1.7c-2.5-.7-5.1-.9-7.6-.5-2.6.3-5,1.2-7.1,2.6q-.6.4-1.1.8t-1.1,1c-.9.8-1.6,1.9-2.4,2.9-.7,1.1-1.3,2.2-1.9,3.4-.5.9-1,1.8-1.4,2.8s-.7,2-.7,3.1Z",
    fill: "url(#eNPyBg0c7kl97-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2299.3,1532.1c-.1,1.4.2,2.9.8,4.3.7,1.3,1.6,2.6,2.6,3.7c1.7,1.8,3.6,3.4,5.6,5s4.1,3.1,6.1,4.7h2.4h2.5q3.6,0,7.2-.3q3.7-.2,7.2-.8q2.9-.5,5.7-1.2t5.6-1.8c-1.1-2.3-2.1-4.6-3-6.9-1-2.4-1.9-4.7-3-7s-2.2-4.5-3.5-6.4c-1.3-2-2.8-3.8-4.7-5.2q-5.6-1.4-11.4-1.9-5.7-.5-11.5-.2-.6.4-1.1.8t-1.1,1c-.9.8-1.6,1.9-2.4,2.9-.7,1.1-1.3,2.2-1.9,3.4-.5.9-1,1.8-1.4,2.8s-.7,2-.7,3.1Z",
    fill: "url(#eNPyBg0c7kl98-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2062.4,1155.1q-.3,0-.6-.1-.2,0-.4-.2-.1-.2-.2-.3q0-.2,0-.4c-.1-2.5.8-4.9,2.2-6.9c1.4-2.1,3.3-3.8,5.5-5c2.2-1.1,4.6-1.8,7-2.2c2.5-.3,5-.4,7.5-.2c5.3.3,10.6,1.4,15.6,3.2s9.7,4.3,14,7.5c3.1,2.3,2.9,3.4,1.4,3.9s-4.3.5-6.3.5q-3.8,0-7.6,0t-7.6,0q-7.6.1-15.3.1-7.6,0-15.2.1Z",
    fill: "url(#eNPyBg0c7kl100-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2043.1,1153.1q.4.3.9.4.4.1.9.2.2.2.4.2t.4.1c1.1.2,2.4.4,3.7.4c1.2.1,2.5.2,3.8.2h.4.4q.9,0,1.6,0q.8,0,1.5.1c3.8.2,6.5-1.6,9.6-3.5c3.2-1.9,6.8-3.9,12.3-3.8q.1,0,.3,0q.2.1.4.1c1.7.4,5.2,1.8,9.5,3.4s9.3,3.4,14,4.6c3.1.7,6.3,1.2,9.5,1.3s6.4-.1,9.5-.7c5.8-1.1,11.6-1.4,17.4-1.5s11.7,0,17.5-.1c6-.1,12.1-.2,18.1-.3c6.1,0,12.1-.1,18.1.1c1.5,0,10.2.1,18.5.2c8.3.2,16.2.5,16.3.9-1-6.2-2.6-12.6-4.7-18.9-2-6.3-4.4-12.4-6.8-18.2-1.4-3.3-3-6.5-4.5-9.6-1.6-3.1-3.3-6.3-4.9-9.4-.5-1.1-1.4-2.9-2.1-4.5s-1.2-3-.8-3.5c-1.8,1.6-4.1,2.9-6.6,4-2.4,1.1-4.9,2.1-7.3,3.2q-.6.3-1.2.5-.6.3-1.2.6c-9.3,4.6-19.5,9.1-29.7,13.5-10.2,4.3-20.5,8.6-30.1,12.7-1.6.7-3.3,1.4-5,2s-3.4,1-5.1,1.2c-6.2.4-13.9-2.8-20.9-6-7-3.3-13.4-6.6-17.2-6.3-1.1,0-5.9,1.1-11.4,2.8s-11.6,4-15.4,6.6c-1.7,1.1-2.8,2.9-3.6,4.8-.7,1.9-1.2,3.8-1.7,5.3-.3.8-1.8,4.8-3.1,8.8s-2.4,7.8-1.7,8.1Z",
    fill: "url(#eNPyBg0c7kl101-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2079.7,1147.5c1.7.4,5.2,1.8,9.5,3.4s9.3,3.4,14,4.6c3.1.7,6.3,1.2,9.5,1.3s6.4-.1,9.5-.7c5.8-1.1,11.6-1.4,17.4-1.5s11.7,0,17.5-.1c6-.1,12.1-.2,18.1-.3c6.1,0,12.1-.1,18.1.1c1.5,0,10.2.1,18.5.2c8.3.2,16.2.5,16.3.9-1-6.2-2.6-12.6-4.7-18.9-2-6.3-4.4-12.4-6.8-18.2-1.4-3.3-3-6.5-4.5-9.6-1.6-3.1-3.3-6.3-4.9-9.4-.5-1.1-1.4-2.9-2.1-4.5s-1.2-3-.8-3.5c-1.8,1.6-4.1,2.9-6.6,4-2.4,1.1-4.9,2.1-7.3,3.2-1.7,10.3-.6,21.4,1,29.9c1.5,8.5,3.5,14.4,3.5,14.4-11.4,1.3-24.1,2.7-36.8,3.8s-25.4,2.1-36.9,2.7c-4.7.3-9.4.5-14.1.4-4.8,0-9.5-.3-14.1-1.1-1.9-.3-3.8-.7-5.8-1-1.9-.2-3.9-.4-5.8-.3q-.4,0-.9.1-.4,0-.8.1Z",
    fill: "url(#eNPyBg0c7kl102-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2053.2,1154.6h.4.4q.6-.9,1.1-1.7.6-.9,1.1-1.8q1-1.7,2.2-3.3q1.1-1.5,2.4-3q.6-.7,1.2-1.4.6-.6,1.3-1.2.8-.5,1.6-.9.9-.4,1.9-.7c1.7-.5,3.5-.8,5.2-1c1.8-.2,3.6-.3,5.4-.4.2,0,.4-.2.4-.4s-.2-.4-.4-.4q-1.5.1-3,.2-1.4.1-2.9.3c-1.2.2-2.4.4-3.6.6-1.3.3-2.5.7-3.6,1.3q-.9.4-1.7,1-.7.6-1.4,1.4-.8.8-1.5,1.6-.7.9-1.3,1.7c-.9,1.2-1.7,2.4-2.5,3.6-.7,1.2-1.5,2.4-2.3,3.6q-.1.3-.2.5-.2.2-.2.4Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2044.9,1153.7q.2.2.4.2t.4.1q.3-.7.5-1.3.3-.6.5-1.3q1-2.2,1.9-4.5t1.9-4.6q.4-1,.7-2q.4-1.1.8-2.2.5-1.1,1.3-2.1.7-.9,1.7-1.7c1.3-1.1,2.9-1.8,4.5-2.3s3.4-.8,5-1.1q1.4-.4,2.8-.6q1.4-.3,2.8-.4c1-.1,1.9-.2,2.8-.3s1.9-.3,2.7-.5c.3,0,.4-.2.3-.4c0-.2-.2-.4-.4-.4-1.1.3-2.2.5-3.3.6s-2.3.2-3.4.4q-1.5.2-3,.5t-3.1.6q-1.3.3-2.6.7-1.4.3-2.6.8t-2.1,1.1q-1,.7-1.8,1.5-.9.9-1.5,1.9-.6.9-1,2.1-.4,1.1-.8,2.2-.4,1-.9,2.1-1.1,2.7-2.2,5.5-1.1,2.7-2.3,5.4Z",
    fill: "#ea8e67"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2112.6,1298.3c10.3,43.6,29.4,85.7,55.2,123.3c25.7,37.5,58.1,70.6,94.9,96q.5.4,1,.7.4.3.9.6c2.5,1.7,4.9,3.5,7.3,5.3c2.4,1.7,4.9,3.5,7.4,5.2c4.5,2.9,9.2,5.6,14.2,8c4.9,2.4,9.9,4.6,14.9,6.6q.9.3,1.8.6.8.2,1.8.2.8,0,1.6-.3.7-.3,1.5-.6c3.4-1.4,6.8-2.9,10-4.7s6.1-4,8.4-6.9q.2-.3.4-.6t.2-.7q0-.2-.1-.5-.1-.2-.2-.5-5.9-12.7-11.5-25.5-5.5-12.9-10.6-26c-3.3-8.2-6.6-16.5-9.7-24.9-3.2-8.3-6.2-16.7-9-25.1-2.8-8.5-5.1-17.1-6.9-25.8-1.7-8.7-2.9-17.5-3.1-26.4-.1-1.7-.1-3.5.1-5.2s.7-3.4,1.6-4.8c1.3-2.2,3.3-3.7,5.7-4.7c2.3-1.1,5-1.7,7.5-2.1c3.7-.7,7.4-1,11.1-1.2c3.7-.3,7.4-.5,11.1-.8q.8-.1,1.5-.2t1.5-.3c2.2-.3,4.5-.8,6.7-1.4c2.3-.6,4.5-1.3,6.7-1.9q.7-.2,1.4-.4t1.4-.4q2.4-.6,4.8-1.3q2.4-.6,4.7-1.3q1-.3,2-.7q1-.3,2-.6c4-1.3,7.9-2.7,11.7-4.3c3.9-1.5,7.9-3.3,11.8-5.3q1.2-.7,2.5-1.3q1.2-.7,2.3-1.3c2.6-1.4,5-2.8,7.4-4.5c2.3-1.6,4.5-3.3,6.5-5.4-4.4-1.2-8.7-2.7-12.9-4.5-4.2-1.9-8.3-3.9-12.3-6.2-4.9-2.7-9.7-5.6-14.3-8.7-4.7-3-9.3-6.2-13.8-9.3-4.4-3.1-8.5-6.1-12.5-9.2-3.9-3.1-7.8-6.4-11.7-10-1.7-1.5-3.4-2.9-5.2-4.3-1.7-1.3-3.5-2.7-5.2-4.1q-1.3-1.1-2.6-2.2t-2.7-2.2q-.5-.4-1.2-.8-.6-.5-1.2-.9-.8-.5-1.7-.9-.8-.4-1.7-.6c-2.6-.4-5.2-1-7.7-1.6-2.6-.7-5.2-1.4-7.8-2-1.8-.5,7.7-.3,17.2-.1c9.6.1,19.1.3,17.2-.2-2.4-.7-15.5-4.3-31.7-8.5-16.2-4.1-35.7-8.7-51-11.5-12.5-2.2-30.2-9.2-47.6-13.3-17.5-4.1-34.6-5.2-46,4.5-10.1,8.7-18.2,19.2-22.9,30.7-4.8,11.6-6.2,24.3-3.1,37.3Z",
    fill: "url(#eNPyBg0c7kl106-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2174,1314.4c.6,6.2,1.9,12.2,3.6,18.1c1.8,6,3.9,11.8,6.2,17.6c9.1,23.4,20,45.4,32.9,66.3s27.6,40.6,44.3,59.5c3.7,4.2,7.6,8.5,10.7,13.1c3.2,4.6,5.7,9.6,6.6,15.1.2,1.1.3,2.3.3,3.4-.1,1.2-.2,2.3-.6,3.4-1.1,2.8-3.4,4.7-6.2,5.7-2.8,1.1-6.1,1.4-9.1,1q.5.4,1,.7.4.3.9.6c2.5,1.7,4.9,3.5,7.3,5.3c2.4,1.7,4.9,3.5,7.4,5.2c5.3,3.5,11,7,16.8,10.3c5.8,3.4,11.6,6.5,17.3,9.4c0,0,1.1-.5,2.4-1.2s2.9-1.4,3.8-2q1.9-.9,3.7-1.9q1.8-1.1,3.6-2.1.8-.4,1.6-.9.9-.5,1.7-1c2.1-1.2,4.3-3.2,6-5c1.6-1.7,2.8-3.2,2.8-3.2s-.6-1.1-1.3-2.6c-.8-1.6-1.7-3.6-2.5-5.2-4.7-10.6-10-21.3-15.2-31.9-5.2-10.7-10.3-21.4-14.9-32-5.7-13.4-11-27.1-15-41-4-14-6.7-28.3-7.1-42.8-.1-1.7-.1-3.5.1-5.2s.7-3.4,1.6-4.8c1.3-2.2,3.4-2.9,5.7-3.2c2.4-.3,5-.2,7.6-.6c3.7-.7,7.3-1.8,11-2.7c3.7-1,7.4-2,11.1-2.3q.8-.1,1.5-.2t1.5-.3q3.4-.8,6.8-1.6q3.3-.9,6.6-1.7.7-.2,1.4-.4t1.4-.4q2.4-.6,4.8-1.3q2.4-.6,4.7-1.3q1-.3,2-.7q1-.3,2-.6c4-1.3,7.9-2.7,11.7-4.3c3.9-1.5,7.9-3.3,11.8-5.3q1.2-.7,2.5-1.3q1.2-.7,2.3-1.3-.7-1.6-1.5-3.1t-1.7-3.1q-1.9-3.7-3.9-7.3-2.1-3.6-4.2-7.1c-4.6-2.5-8.3-6.6-11.5-11.1-3.3-4.5-6-9.6-8.4-14.1-.8-1.4-.8-9.6-.7-17.4.1-7.9.4-15.4.1-15.4-8.6.8-19.6.1-35.1-2.3-15.4-2.4-35.2-6.5-61.2-12.5c0,0,.5,3.8,1.1,8.1s1.3,9,1.5,10.7c.8,5.5,1.8,11,3.2,16.4c1.3,5.4,3,10.8,5,16q1.1,3.1,2.4,6.2q1.2,3.1,2.5,6.2c1.2,2.6,2.5,5.1,3.9,7.5c1.3,2.5,2.8,4.9,4.2,7.4.9,1.4-1.6,1.6-4.3,1.5-2.7-.2-5.7-.7-6-.7q-5.2-.6-10.4-1.2t-10.4-1.3c-9.7-1.1-19.3-2.6-28.9-4.3s-19.2-3.7-28.8-5.8c-1.5-.4-4.7-1.3-7.6-1.7-3-.3-5.7,0-6.3,2.2q-.2.9-.2,1.9t.1,1.9Z",
    fill: "url(#eNPyBg0c7kl107-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2282.3,1615.4q0,.1,0,.3.1.1.1.2c.2,2.5.5,5,1.2,7.2.8,2.3,1.9,4.4,3.8,5.9c6.7-2.4,13-5.7,19.2-9.3c6.1-3.6,12.2-7.4,18.5-10.7c3.9-2,7.8-3.8,11.8-5.6s7.9-3.6,11.7-5.6c3.9-2,7.7-4.2,11.2-6.8c3.5-2.5,6.8-5.4,9.6-8.7.9-1.1,1.7-2.2,2.5-3.5.7-1.2,1.3-2.5,1.7-3.8q.1-.4.2-.8q0-.4-.1-.8c0,0-.2-.1-.4-.3-.3-.2-.6-.5-.9-.6-2.7-1.5-5.3-3.3-7.8-5.3-2.5-2.1-4.8-4.3-6.9-6.5-.9-1-1.7-2.6-2.6-3.9-.9-1.2-2.1-2-3.7-1.4-.8.2-1.6.7-2.3,1.4-.8.6-1.6,1.2-2.3,1.8q-.3.2-.6.4t-.5.4c-4.8,2.8-10,4.3-15.3,5.6s-10.7,2.5-15.7,4.6c-4.7,2-9.1,4.3-13.2,7.2-4.2,2.9-7.9,6.3-11.2,10.2-1.5,1.8-2.9,3.8-4.1,5.8-1.1,2.1-2.1,4.3-2.8,6.6-.8,2.6-1.1,5.3-1.2,7.9-.2,2.7-.1,5.4.1,8.1Z",
    fill: "url(#eNPyBg0c7kl108-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2282.4,1615.9c.2,2.5.5,5,1.2,7.2.8,2.3,1.9,4.4,3.8,5.9c6.7-2.4,13-5.7,19.2-9.3c6.1-3.6,12.2-7.4,18.5-10.7c3.9-2,7.8-3.8,11.8-5.6s7.9-3.6,11.7-5.6c3.9-2,7.7-4.2,11.2-6.8c3.5-2.5,6.8-5.4,9.6-8.7.9-1.1,1.7-2.2,2.5-3.5.7-1.2,1.3-2.5,1.7-3.8q.1-.4.2-.8q0-.4-.1-.8c0,0-.2-.1-.4-.3-.3-.2-.6-.5-.9-.6-2.7-1.5-5.3-3.3-7.8-5.3-2.5-2.1-4.8-4.3-6.9-6.5-.9-1-1.7-2.6-2.6-3.9-.9-1.2-2.1-2-3.7-1.4-.8.2-1.6.7-2.3,1.4-.8.6-1.6,1.2-2.3,1.8-.1,1.7-.1,3.4-.3,5.1s-.5,3.4-1.2,5.1c-1.7,4-4.1,7.7-6.9,11-2.7,3.4-5.8,6.5-9,9.5-3.3,3.1-6.8,5.9-10.4,8.7-3.6,2.7-7.4,5.3-11.1,7.8-3.2,2.1-6.6,4.4-10.2,6.3-3.5,1.9-7.3,3.3-11.2,3.7q-1,.1-2,.1t-2.1,0Z",
    fill: "url(#eNPyBg0c7kl109-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2283.5,1622.9q.2,1.4.4,2.8t.6,2.8c.3,1,.6,2,1.1,2.9.5.8,1.3,1.4,2.3,1.8c1.1.3,2.3.3,3.4.2c1.2-.2,2.3-.5,3.4-.8c2.5-.6,5-1.3,7.4-2.1c2.5-.8,4.9-1.6,7.2-2.8q2.2-1,4.3-2.3t4.2-2.7c8.5-5.4,17-10.9,25.1-16.8c8.2-5.9,16-12.2,23-19.4c1.2-1.2,2.3-2.4,3.3-3.8s1.8-2.8,2.3-4.5c.1-.6.4-1.1.4-1.6.1-.4,0-.7-.7-.8c0,0-.9.4-1.9.9-1,.4-2.1,1-2.5,1.2-2.1,1.3-4.3,2.7-6,3.8-1.7,1-2.9,1.8-3.1,2q-4.9,3-9.9,5.9-4.9,2.9-10,5.7c-4.4,2.3-8.8,4.6-13.2,7-4.3,2.4-8.6,4.9-12.8,7.6-4,2.6-8,5.6-12.2,8-4.2,2.5-8.6,4.5-13.4,5.2q-.7.1-1.4.1t-1.3-.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2307.4,1574.6q1.7,2.2,3.3,4.5q1.7,2.3,3.3,4.6.3.4.7.5t.8-.1c.2-.1.4-.4.5-.7s.1-.6-.1-.8q-1.6-2.3-3.3-4.6-1.6-2.3-3.3-4.6-.3-.3-.7-.5-.4-.1-.8.1c-.3.2-.5.4-.6.7c0,.3,0,.6.2.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2297.9,1580.8q1.7,2.3,3.4,4.6q1.6,2.3,3.2,4.6.3.4.7.5t.9-.1c.2-.2.4-.4.5-.7c0-.3,0-.6-.2-.8q-1.6-2.4-3.2-4.6-1.7-2.3-3.4-4.6-.3-.3-.7-.5-.4-.1-.8.1c-.2.2-.4.4-.5.7s-.1.6.1.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290.4,1588.1q1.7,2.2,3.3,4.5q1.7,2.3,3.3,4.6.3.4.7.5t.8-.1c.2-.1.4-.4.5-.7.1-.2.1-.6-.1-.8q-1.6-2.3-3.3-4.6-1.6-2.3-3.3-4.5-.3-.4-.7-.5-.4-.2-.8.1c-.3.1-.5.4-.5.6-.1.3-.1.6.1.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2284.5,1628.5q.2.6.4,1.2.3.6.5,1.2c.7,1.2,1.6,2.3,2.7,3.1c1.1.9,2.4,1.4,3.7,1.5q1.1-.1,2.2-.3q1-.3,2-.7q6.5-2.3,12.8-5.2q6.2-2.9,12.2-6.4q4.4-2.5,8.5-5.2q4.2-2.8,8.4-5.6q6.7-4.4,13.3-8.9q6.7-4.5,13.4-8.9c2.3-1.6,4.8-3.4,6.8-5.4c2-2.1,3.4-4.4,3.8-7.2.2-1.4.2-2.8,0-4.2-.2-1.3-.7-2.7-1.5-4.1c0,.1-.9.6-2.1,1.4-1.3.9-3.1,2-4.8,3.1q-.3.8-.7,1.5-.4.8-.8,1.5c-2.3,3.7-5,6.9-8,9.9-2.9,2.9-6.2,5.6-9.7,8.1-6.1,4.5-12.6,8.5-19.1,12.3-6.6,3.8-13.3,7.2-20,10.6-3.4,1.7-6.9,3.2-10.4,4.3-3.6,1.2-7.2,2-11.1,2.4q-.5,0-1.1,0t-1.4,0Z",
    fill: "url(#eNPyBg0c7kl115-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2398.5,1575.8c.4,1.9,1,4.9,1.6,7.9.7,3.1,1.4,6,2,7.8.2.7.4,1.8.7,2.9s.6,2.1,1,2.6s1.1.7,1.8.8s1.5,0,2.1.1c2,.2,3.9.4,5.7.4c1.9,0,3.8-.3,5.7-1c1.1-.4,1.6-.8,1.9-1.4.3-.7.4-1.6.4-3q.1-1.7.1-3.4.1-1.7.1-3.4v-.3-.2c.2-4,.7-8,1.1-11.9.5-4,.9-7.9,1-11.9q0-.3-.2-.7-.1-.5-.2-1-.2-.6-.4-1.2-.1-.7-.2-1.4c-.1-1.4-.1-2.3-.3-3.1-.3-.7-.7-1.3-1.8-2.2-2.4-2-5.2-2.7-8-2.4s-5.6,1.7-7.9,3.8q-.1.1-.2.2-.2.2-.3.3c-3.2,3-5,6.1-5.9,9.7-.9,3.5-.7,7.4.2,12Z",
    fill: "url(#eNPyBg0c7kl117-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2398.5,1575.8h.1q2.8,1.9,5.8,3.5t6,2.9q2.8,1.2,5.6,2.2q2.8.9,5.6,1.7v-.3-.2c.2-4,.7-8,1.1-11.9.5-4,.9-7.9,1-11.9q0-.3-.2-.7-.1-.5-.2-1-4.5-2.3-9.3-3.8t-9.8-2.2c-3.2,3-5,6.1-5.9,9.7-.9,3.5-.7,7.4.2,12Z",
    fill: "url(#eNPyBg0c7kl118-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2391.9,1540.7c.7,5.2,1.5,10,2.6,14.7c1.2,4.7,2.8,9.2,5.2,14q.3.7.7,1.2.4.6,1,1c.4.3,1,.4,1.5.4s1.1,0,1.6-.1q3.4-.3,6.8-.8q3.3-.6,6.6-1.3.6-.1,1.2-.3t1.1-.6c.4-.3.6-.7.8-1.2.2-.4.4-.9.5-1.4c7.3-27.4,16-54.2,25.5-80.9c9.4-26.7,19.4-53.2,29.3-79.7c1.6-4,3.1-8.1,4.5-12.2c1.3-4.1,2.6-8.3,3.5-12.5.5-2.3-1-2.9-3-3-2,0-4.5.5-5.9.5q-2.7-.1-5.3-.1-2.7,0-5.4.1c-9.9.1-19.9.7-29.9,1.3-9.9.7-19.9,1.5-29.8,2.2-.7,0-1.5.1-2.2.2-.8.2-1.4.5-2,.9-.5.5-.9,1.1-1.2,1.7s-.5,1.3-.7,2c-6.7,24.6-10.3,50.3-11.3,76.2s.7,52.1,4.3,77.7Z",
    fill: "url(#eNPyBg0c7kl119-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2393.3,1620.4q.2.1.4.2.2,0,.4.1c4,1.5,8.3,2.1,12.7,2c4.3,0,8.7-.5,13-1.2c1.6-.3,3.3-.7,4.8-1.3s2.8-1.5,3.7-2.9c.5-.9.8-1.8,1-2.8.1-1,.2-2.1.2-3.1q0-2.2-.2-4.4t-.5-4.4c-.1-1.3-.5-2.4-.8-3.5-.4-1.2-.8-2.3-1.1-3.5-.1-.3-.2-.8-.2-1.4-.1-.5-.2-1.1-.2-1.7q-.2-.6-.3-1.1-.2-.6-.4-.9-.2-.2-.4-.3-.2-.2-.4-.3c-.4-.2-.8-.3-1.2-.3-.5-.1-.9-.1-1.4-.2q-2.1-.3-4.3-.5-2.1-.3-4.2-.5c-3-.2-6.5-.6-9.7-.2-3.2.3-6.1,1.3-7.9,4-1.8,2.6-3.2,5.4-4.3,8.5-1,3-1.7,6.1-2.1,9.3q0,0,0,.1-.1.1-.1.2-.1.8-.1,1.6-.1.7-.1,1.5c0,.9-.1,1.9,0,2.8s.3,1.7,1.1,2.5q.5.6,1.2,1t1.4.7Z",
    fill: "url(#eNPyBg0c7kl120-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2392.5,1622.3c1.4.9,3.5,1.4,5.8,1.6c2.2.3,4.4.3,6,.3c3.5-.1,9.8.4,15.6-.1c5.8-.6,11-2.1,12-6.3.3-1.3.4-2.8.4-4.3-.1-1.4-.4-2.9-.8-4.3q-.2-.8-.5-1.6t-.6-1.5q-1-2.5-1.9-5.2-.9-2.6-1.6-5.3c-.1-.3-.2-.8-.2-1.4-.1-.5-.2-1.1-.2-1.7q-.2-.6-.3-1.1-.2-.6-.4-.9-.2-.2-.4-.3-.2-.2-.4-.3-.5.9-1,1.7-.5.7-1,1.5c-2.1,2.9-4.6,5.4-7.5,7.5-2.8,2.1-5.9,3.8-9.2,5.2q-3.9,1.6-8,2.6t-8.4,1.6q0,0,0,.1-.1.1-.1.2-.1.8-.1,1.6-.1.7-.1,1.5c-.1,1.7-.1,3.5.3,5c.3,1.6,1.1,3,2.6,3.9Z",
    fill: "url(#eNPyBg0c7kl121-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2391.9,1540.7q1.2,8.9,2.8,17.7q1.5,8.8,3.4,17.4c0,0,4.6-.2,9.7-.5s10.5-.7,12.2-1c.8-.2,1.6-.3,2.2-.3.5-.1.9-.1.9-.1s.9-2.8,1.9-6c1.1-3.2,2.2-6.7,2.5-8.1c1.4-4.3,3-9.4,4.6-14.4c1.5-5,3.1-9.8,4.2-13.7c6.9-22.8,14.8-47.1,23.5-72s18.1-50.3,28.1-75.5c1.4-3.7-.5-5.1-3.3-5.6-2.9-.5-6.8-.1-9.2-.1q-2.7-.1-5.3-.1-2.7,0-5.4.1-1.4,1.1-2.5,2.6t-1.9,3.2c-1.3,2.7-2.1,5.5-2.6,8.4-.6,2.9-.9,5.9-1.2,8.8-.4,2.9-.9,5.7-1.6,8.5-.6,2.8-1.4,5.6-2.1,8.4q-2.1,8.7-4.5,17.4t-5.1,17.4c-5.3,16.7-12.1,32.2-20.6,46.7s-18.7,28-30.7,40.8Z",
    fill: "url(#eNPyBg0c7kl122-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2392.3,1622.4c1.4.9,3.6,1.4,5.9,1.7s4.6.4,6.2.4c3.4-.1,9.8.4,15.6-.2c5.9-.5,11.1-2.1,12.1-6.3.4-1.3.4-2.9.3-4.4-.2-1.5-.5-3-.9-4.4-2.2,1.7-4.9,2.4-7.7,2.8s-5.8.4-8.4.4q-4.6.2-9.3,0t-9.4-.9q-1.7-.2-3.4-.5-1.8-.3-3.5-.7-.1.8-.2,1.6t-.2,1.6c0,1.7-.1,3.4.3,5c.3,1.6,1.1,3,2.6,3.9Z",
    fill: "url(#eNPyBg0c7kl123-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2181.3,1231.6c-3.5-1.2-7.1-2.2-10.7-2.7-3.6-.6-7.3-.7-10.8,0-4.8.9-9,3.1-12.9,5.9-3.9,2.9-7.4,6.3-10.8,9.8-1.6,1.7-3.2,3.4-4.6,5.2-1.5,1.8-2.7,3.8-3.7,5.9s-1.5,4.5-1.6,6.8.4,4.6,1.5,6.6c1.2,2.2,3,3.8,5.1,5.2c2.1,1.3,4.5,2.3,6.7,3.3q15.8,6.5,31.9,11.7q16.2,5.2,32.8,9.2c.7.1,1.5.3,2.3.4.8,0,1.6,0,2.4-.3c1.1-.5,1.8-1.3,2.3-2.4.6-1,.9-2.3,1-3.4c1.1-7.3,1.3-13.8.4-20.3-.8-6.5-2.7-13-5.6-20.4-2.4-6.1-5.7-10.2-10-13.3-4.2-3.1-9.5-5.2-15.7-7.2Z",
    fill: "url(#eNPyBg0c7kl124-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2191.1,1338.6c10.3,8.6,21.8,15.9,34.1,21.6c12.2,5.7,25.2,9.8,38.4,12.2c3.4.6,6.8,1.1,10.2,1.4c3.4.2,6.8.3,10.2-.1.8-.1,1.6-.2,2.4-.4.7-.2,1.5-.5,2.1-1c4-3,2.9-5.7.3-7.7-2.7-2.1-6.8-3.4-9-3.7q-7.5-1.1-15-2.5t-14.9-3q-7.5-1.6-14.9-3.5t-14.8-4q-3.7-1-7.3-2.1-3.7-1.1-7.3-2.3c-2-.6-4.8-1.2-7.6-2-2.7-.7-5.4-1.6-6.9-2.9Z",
    fill: "#a31d2d"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2189.5,1097.7c.5,4.2,1.1,8.1,1.8,11.9.6,3.8,1.4,7.6,2.2,11.8s2,8.4,3.4,12.6s3.2,8.3,5.1,12.3q2.1,4.3,4.7,8.5q2.5,4.1,5.5,8q1.5,2.1,3.2,4.1t3.5,3.9c3.4,3.6,6.2,5.4,9.3,6.1c3.2.7,6.6.2,11.3-.8c3.8-.9,7.7-1.8,11.5-2.8c3.9-1,7.7-2.1,11.4-3.3c15.3-5.1,30.8-10.2,45.9-16c15.1-5.9,29.9-12.6,43.8-21-1.6,20.8-6.7,41.2-14.9,60.3s-19.5,36.8-33.4,52.3c-.6.6-1.1,1.2-1.6,1.9s-.9,1.4-1,2.2c-.2.7-.2,1.4-.1,2.1s.3,1.5.5,2.1c1.1,3.9,2.6,7.6,4.3,11.2s3.6,7.1,5.7,10.6c10.1,16.6,23.9,30.2,39.8,40.7c16,10.5,34.2,17.9,53.2,22.2c7.9,1.7,15.4,4.2,23,6.5c7.5,2.4,15.1,4.5,23.1,5.6s15.9,2.1,23.8,2.7c7.9.7,15.9,1.1,24,1.1c2.8,0,5.6,0,8.4.1c2.7.1,5.5.3,8.2.6c2.4.2,4.8-.2,7.2-1c2.3-.8,4.5-1.9,6.5-3c4.1-2.3,7.6-5.3,10.7-8.7c3-3.4,5.6-7.2,7.9-11c5.1-8.4,9.6-17.1,13.7-25.9c4.1-8.9,7.8-17.9,11.2-26.9c12.5-33.8,23.9-68.3,31.2-103.5c7.4-35.2,10.6-70.9,6.9-106.9-1.4-13.6-3.6-27.6-7.2-41.2s-8.5-26.9-15-39.3q-1.6-3.1-3.3-6.2t-3.5-6.2c-3.8-6.4-6.8-11.8-10.9-15.4-4.1-3.7-9.2-5.5-17.2-4.8-10.8,1-21.6,1.7-32.4,1.8-10.8.2-21.7-.2-32.4-1.5q-7.8-.9-15.5-2.4-7.6-1.5-15.1-3.7c-1.8-.6-3.6-1.3-5.3-2-1.7-.8-3.3-1.6-5.1-2.3s-3.1-.9-4.5-.8c-1.4.2-2.9.6-4.8,1.1q-5.6,1.5-11.2,3.1t-11.1,3.4c-7.3,2.3-14.5,4.8-21.6,7.6-7.1,2.7-14.1,5.7-20.9,9.1q-1.1.5-2.2,1.1-1.1.5-2.1,1.1-.2,0-.4.1-.1.1-.3.2c-10.6,5.8-20.6,12.8-30.3,20.1-9.7,7.4-19.1,15.1-28.6,22.4-9.9,7.6-19.9,15.2-30.1,22.6s-20.6,14.6-31.3,21.4q-2.2,1.4-4.4,2.8-2.3,1.4-4.6,2.8c-5.9,3.5-12,7-18.3,10s-12.9,5.6-19.7,7.4q-.8.2-1.7.4-.8.2-1.7.4c-1.5.3-3,.7-4.2,1.1s-2.2.9-2.7,1.4c-1.4.9-1.8,3.4-1.8,6.1-.1,2.7.3,5.7.5,7.7Z",
    fill: "url(#eNPyBg0c7kl127-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2427.3,1022.7q0,.3,0,.7t0,.8q.2,3.4.1,6.8t-.5,6.7c-.3,2.3-.8,4.5-1.4,6.7s-1.3,4.4-2,6.5q-.4,1.5-1,3-.5,1.6-1.1,3.1-4.5,13.2-10.5,25.9t-13.3,24.8c-5.4,8.8-11.4,17.4-18,25.5-6.5,8.1-13.6,15.9-21.4,23.1q-2.8,2.7-5.8,5.3t-6.1,5.1q2.3-8.3,3.7-16.8q1.5-8.4,2.2-16.9c-12.9,7.7-26.3,13.9-40.1,19.5-13.8,5.5-27.9,10.3-42,15q-.6.2-1.2.4-.7.2-1.3.4-4.6,1.5-9.3,2.9-4.6,1.3-9.3,2.6-2.4.6-4.7,1.2-2.4.5-4.8,1.1c-4.6,1-8.1,1.5-11.2.8-3.2-.6-6-2.5-9.4-6q-1.1-1.3-2.2-2.5-1-1.2-2-2.5-2.7-3.2-5.1-6.6-2.3-3.4-4.3-6.9-.9-1.5-1.7-3t-1.5-3c.5,1,8.9-.9,17.6-3.1c8.7-2.3,17.7-4.9,19.4-5.3q10.8-2.8,21.5-5.8q10.7-3.1,21.3-6.5c11-3.5,21.7-7.3,32.1-11.7c10.4-4.3,20.4-9.4,30-15.5c10-6.4,19.5-13.6,28.3-21.4s16.9-16.3,24.2-25.3q5.1-6.1,9.6-12.7q4.6-6.6,8.6-13.4c1.4-2.3,2.6-4.6,3.8-6.9s2.5-4.7,3.9-6.9c.3-.6.7-1.3,1.2-1.9.4-.7.9-1.3,1.5-1.6.7,2.2,1.2,4.6,1.5,7c.4,2.4.5,4.9.7,7.3Z",
    fill: "url(#eNPyBg0c7kl128-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2369.1,970.8q11-.7,20,1.9q9,2.5,16,8.3c5.5,4.7,10.2,10.2,13.8,16.1s6.1,12.3,7.2,18.7c2.3,12.5.3,25.1-3.8,37.2-4,12.1-10.2,23.7-16.1,34.4l1.1.4l1,.5c6-10.8,12.1-22.6,16.2-34.9s6.2-25.1,3.8-37.9c-1.2-6.7-3.8-13.3-7.5-19.4s-8.5-11.8-14.2-16.5q-6.6-5.5-14.9-8.3-8.3-2.7-18.3-2.7-1.1.5-2.2,1.1-1.1.5-2.1,1.1Z",
    fill: "url(#eNPyBg0c7kl130-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2389.9,983.2c-2.9-2.6-6.6-4.4-10.6-5.3-4-.8-8.2-.8-12.1.2-3.3.9-6.3,2.4-9.1,4.2s-5.4,3.9-7.9,6c-21.6,17.9-42.3,37.2-64.3,54.7-21.9,17.5-45.1,33.4-71.6,44.5-.5.2-1.1.5-1.6.8-.5.2-1,.6-1.4,1q-.6.7-.8,1.5-.3.8-.4,1.6c-.6,4.2.4,8.5,2.4,12.3c2.1,3.7,5.3,7.1,9.2,9.5c3.8,2.4,8.2,3.9,12.8,4.8c4.5.9,9.3,1,13.9.6c4.7-.4,9.2-1.3,13.7-2.6c4.4-1.2,8.8-2.8,13.1-4.4c24.2-9.3,47.2-22,67.1-37.9s36.7-34.8,48.5-56.4c3.1-5.7,5.9-11.9,6.3-18c.5-6-1.3-12-7.2-17.1Z",
    opacity: 0.3,
    fill: "url(#eNPyBg0c7kl131-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2348.3,1025.5c-.2-6.3,6.1-12.4,12-18.4c5.9-5.9,11.4-11.8,9.4-17.7-1.3-4.1-5.4-3.9-9.7-2.3-4.2,1.6-8.6,4.7-10.5,6.3-3.3,2.7-6.7,6.2-9.4,10.1s-4.8,8-5.2,11.9c-.7,5.5,1.5,9.1,4.5,10.8c3,1.6,6.7,1.4,8.9-.7Z",
    fill: "url(#eNPyBg0c7kl132-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2189.5,1097.7c.5,4.2,1.1,8.1,1.8,11.9.6,3.8,1.4,7.6,2.2,11.8s2,8.4,3.4,12.6s3.2,8.3,5.1,12.3q2.1,4.3,4.7,8.5q2.5,4.1,5.5,8-2.8-5.2-5.1-10.5-2.3-5.4-4.2-11c-2.2-6.5-3.9-13.2-5-20-1.2-6.8-1.8-13.7-1.8-20.5c0-3.2,0-6.5.2-9.8s.6-6.5,1.4-9.6c-1.5.3-3,.7-4.2,1.1s-2.2.9-2.7,1.4c-1.4.9-1.8,3.4-1.8,6.1-.1,2.7.3,5.7.5,7.7Z",
    fill: "url(#eNPyBg0c7kl133-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2625.5,1069.8q1.4-13.6,1.7-27.1.4-13.6-.4-26.9c-.5-8.7-1.9-19.1-4.1-28.2s-5.2-16.9-8.6-20.4c-4.3-4.4-10-8.3-16-11.6-6-3.4-12.3-6.3-17.9-9-1-.4-2-.9-3-1.2-1-.4-2-.6-3-.6-1.3.1-2.4.4-3.5.9-1.2.5-2.3,1.1-3.3,1.7-11.5,6.5-24.9,9.2-38.6,10s-27.7-.4-40.3-1.9q-7.8-.9-15.5-2.4-7.6-1.5-15.1-3.7c-4.3-1.3-6-3.6-7.7-5.1-1.6-1.5-3.2-2.2-7.3-.4-1.3.2-2.6.6-3.8,1.1-1.3.5-2.6.9-3.9,1.2c4.6,4,9.9,8.2,15,12.1s10.1,7.5,14,10.3c6.1,4.3,13.8,8.6,21.3,12.2c7.4,3.6,14.6,6.5,19.5,8.4c10,3.6,17.6,6.3,24.3,8.1c6.8,1.7,12.8,2.6,19.7,2.8-1,6.7-3.4,15.8-6.1,24.4-2.7,8.7-5.7,16.7-7.5,21.4-4,9.9-8.6,19.4-13.8,28.7s-10.9,18.2-17.2,26.8c-20.7,28.4-47.4,52.8-78,72.2-30.5,19.5-64.9,33.9-101,42.5q-4.7,7.8-10.1,15.2t-11.5,14.3c-.6.6-1.1,1.2-1.6,1.9s-.9,1.4-1,2.2c-.2.7-.2,1.4-.1,2.1s.3,1.5.5,2.1c1.1,3.9,2.6,7.6,4.3,11.2s3.6,7.1,5.7,10.6c10.1,16.6,23.3,31.2,38.7,42.7c15.4,11.6,33,20,52,24.2c8.8,2,17.6,3.9,26.4,5.6c8.8,1.8,17.6,3.4,26.5,4.7c4.8.6,9.6,1.3,14.4,1.9c4.9.6,9.7,1,14.5,1.4c4.6.3,9.4.6,14.1.8c4.8.1,9.5.1,14.1-.2c2.9-.3,5.7-.7,8.4-1.4s5.4-1.7,7.8-3.1c4.2-2.3,7.7-5.6,10.8-9.2c3-3.6,5.7-7.7,8.1-11.6c5.1-8.4,9.6-17.1,13.7-25.9c4.1-8.9,7.8-17.9,11.2-26.9c4.5-12.1,8.6-24.2,12.6-36.4c3.9-12.3,7.7-24.5,11.3-36.9c6.4-21.5,12.6-43.9,17.8-66.7c5.2-22.7,9.3-45.9,11.5-68.9Z",
    fill: "url(#eNPyBg0c7kl134-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2417.2,1071.2c-3.3,8.8-6.1,15.6-9.4,22.1-3.2,6.6-7,12.9-12.3,20.9-5.6,8.6-11.1,15.5-17.1,22.1-5.9,6.6-12.4,12.8-20.2,20q-2.8,2.7-5.8,5.3t-6.1,5.1c1.5-5.5,2.5-10.4,3.3-15.7s1.6-10.9,2.5-18c1.8-1,6.5-3.6,11.2-6.3s9.4-5.4,11.3-6.7c3.2-2.3,6.3-5,9.4-7.7c3-2.8,6-5.7,8.9-8.2c3.6-3.3,6.4-6.7,8.5-9.6c2.2-3,3.7-5.6,4.8-7.1c3-4.1,5.4-7.4,7.2-10.1s3.1-4.7,3.8-6.1Z",
    fill: "url(#eNPyBg0c7kl135-fill)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2438.9,945.4q0,.1.1.2.2.2.4.3c2.7,2,5.5,3.8,8.4,5.7c2.9,1.8,5.9,3.6,8.7,5.5c5,3.3,11,5.9,17.2,7.9c6.3,2.1,12.8,3.5,19.1,4.4c10.8,1.6,21.8,1.5,32.7.2c10.9-1.2,21.7-3.6,32.1-6.5c3.3-1,6.7-2,9.8-3.4c3-1.4,5.7-3.1,7.7-5.5c1.5-1.7,2.5-3.8,2.9-5.8.4-2.1.2-4.2-1.2-6-1.1-1.6-2.1-3.1-3.4-4.5-1.2-1.4-2.7-2.8-4.8-4.4-2.3,2-4.5,3.7-6.9,5.5s-5.1,3.6-8.4,5.6c-3.8,2.4-7.3,4-11.1,5.1-3.7,1.1-7.7,1.8-12.4,2.4-4.3.6-8.5,1-12.7,1.1s-8.4-.1-12.8-.5c-4.7-.6-9.4-1.5-13.9-2.7-4.6-1.3-9-2.8-13.2-4.5q-3.3-1.3-6.5-2.8t-6.2-3.2q-1.5-.9-3-1.8-1.4-1-2.7-2-.9-.7-1.3-1.2-.5-.4-.5-.4c-.6-.2-1.5-.1-2.4,0-1,.1-2,.2-2.9.4-1.1.3-3.1,1.2-5.1,2.3s-4,2.5-5,3.8c-.9,1-1.6,2.1-2.1,3s-.7,1.5-.6,1.8Z",
    fill: "url(#eNPyBg0c7kl137-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2439.4,945.9c.7,1.2,1.8,2.1,2.9,3c1.2.8,2.4,1.6,3.6,2.5c5.8,4.2,12,7.9,18.6,11.1c6.5,3.1,13.5,5.6,20.9,7.3c7.4,1.8,15.1,2.9,22.9,3.2c7.7.4,15.5,0,23.1-1.1q6.3-.9,12.5-2.4q6.2-1.4,12.2-3.5c5.3-1.8,10.4-4.2,15.3-7.1s9.5-6.3,13.7-10c0,0-.7-1-1.7-2.3-1-1.2-2.3-2.8-3.5-4.1-1.4-1.7-3.6-3.3-5.3-4.6-1.8-1.2-3.2-2.1-3.2-2.1-.7,1.4-1.2,2.7-1.7,4-.6,1.3-1.1,2.6-1.9,3.9-1.8,2.9-4,5.6-6.5,8-2.5,2.5-5.4,4.6-8.5,6.5q-2.7,1.7-5.6,3.1-3,1.3-6.1,2.3c-8,2.7-16.4,3.9-25,4s-17.4-.8-25.8-2.4c-9.1-1.7-18.1-4.1-26.7-7.3s-16.8-7.2-24.2-12Z",
    fill: "url(#eNPyBg0c7kl138-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2502.5,956c-7-1.5-14.1-3.2-20.9-5.5-6.9-2.3-13.3-5.2-18.9-9.2-.7-.5-1.5-1-2.3-1.5-.8-.4-1.7-.9-2.4-1.4q-.5-.4-1.1-.8-.5-.4-1.1-.7t-1.3-.5-1.4-.1q-.8,0-1.6.2-.7.3-1.4.7-.7.3-1.4.8-.6.4-1,1c-.4.5-.5,1.1-.5,1.7s.1,1.2.3,1.8c.8,2.1,2.4,3.9,4.2,5.5c1.9,1.7,4.2,3.1,6.4,4.5c4.8,2.9,10.2,5.1,15.8,6.6s11.5,2.4,17.4,2.7q4.4.3,8.9.3q4.4,0,8.9-.3c1.9-.1,5.8-.8,9.3-1.5s6.5-1.3,6.5-1.3-1.8-.1-3.7-.2c-2-.1-4.1-.3-4.7-.3q-3.4-.5-6.8-1.1-3.3-.6-6.7-1.3-.1,0-.2,0-.2-.1-.3-.1Z",
    fill: "url(#eNPyBg0c7kl139-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2464.6,946.1c-2.3-.2-4.2-1.9-6.1-3.5-1.9-1.5-3.8-3-6.1-2.8-1.6.1-1.7,1.1-1.3,2.1.3,1,1.2,2.1,1.7,2.6.8.8,2,1.7,3.3,2.5c1.2.8,2.7,1.4,4.1,1.6c2,.4,3.4.1,4.2-.5s.9-1.4.2-2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2477.6,791.6q.1-.1.2-.3.1-.1.2-.3.9-1.3,1.9-2.5t2.1-2.4q1-1.1,2-2.2q1.1-1.1,2.2-2.1q2.4-2,5.1-3.4t5.8-2c4.4-.8,8.1.8,10.7,3.6c2.7,2.9,4.3,6.9,4.7,10.9.5,4.5-.6,9.1-2.7,13.2-2,4.1-5.1,7.8-8.4,10.5-2.3,1.9-5,3.5-7.8,4.5-2.9,1-5.9,1.3-8.9.7-.6-.1-.9-.2-1.1-.4s-.3-.6-.5-1.1q-.2-.9-.4-1.7-.3-.8-.5-1.6-.5-1.7-.9-3.4-.5-1.7-1-3.4-.9-3.4-1.9-6.8-.9-3.4-1.9-6.9c-.1-.6,0-1.1.2-1.5.2-.5.5-.9.9-1.4Z",
    fill: "url(#eNPyBg0c7kl142-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2486.8,812.9c.8.3,2,.2,3.1-.1c1.1-.2,2.2-.6,2.9-.9q1.4-.6,2.7-1.5q1.3-.8,2.4-1.9c1.1-1.2,2.2-2.8,2.9-4.6s1.1-3.8,1.1-5.6q-.1-1.3-.4-2.5-.4-1.2-1.1-2.3c-.7-.8-1.6-1.6-2.6-2.2-1.1-.6-2.2-1.1-3.2-1.3-2.1-.4-3.9-.3-5.6.4s-3.2,1.9-4.5,3.4q-.8.9-1.4,1.8-.5.9-1,1.8-.1.1-.2.3-.1.1-.1.3-.3.4-.4.7-.2.4-.4.8c.7-1,1.7-1.9,2.7-2.6c1.1-.6,2.3-1,3.4-1q.9,0,1.8.4.8.3,1.6,1.1c1.5,1.4,2,3.3,2,5.3s-.7,4-1.5,5.6c-.6,1-1.1,1.8-1.8,2.6-.7.7-1.5,1.3-2.4,2Z",
    fill: "#910f2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503.6,784.3c-.3-3.6-2.8-5.3-5.7-5.7-3-.4-6.4.6-8.6,2.3-.6.5-1.2,1.1-1.8,1.6-.6.6-1.2,1.2-1.6,1.9-.4.6-.7,1.4-.7,2.2c0,.7.4,1.4,1.2,1.7.7.2,1.5.1,2.4-.1.8-.1,1.6-.3,2.3-.4q1.4,0,2.7.2q1.4.1,2.7.3c.8.2,1.6.3,2.4.2.7-.1,1.4-.3,2.2-.7.7-.3,1.4-.9,1.9-1.5.5-.7.8-1.4.6-2Z",
    fill: "url(#eNPyBg0c7kl144-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2481,799.5c.7-1,1.7-1.9,2.7-2.6c1.1-.6,2.3-1,3.4-1c1-.5,2.1-.2,3.1.4s1.9,1.4,2.4,2.2c.7.8,1.2,1.9,1.5,3c.4,1.1.5,2.3.4,3.4-.1.8-.2,2-.6,3.2s-.9,2.2-1.8,2.6c1.5-.5,3-1.5,4.2-2.7s2.2-2.7,2.9-4.1c.6-1.2.9-2.4,1-3.7s-.1-2.6-.5-3.9c-.4-1.5-1.3-2.7-2.4-3.5-1.2-.8-2.6-1.3-4.2-1.4-2.3-.1-4.4.5-6.2,1.5-1.9,1.1-3.5,2.7-4.8,4.5q-.1.1-.2.3-.1.1-.1.3-.3.4-.4.7-.2.4-.4.8Z",
    fill: "#b22842"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2444.4,776.1c0,.5-.6.2-1.3-.2-.6-.4-1.3-.9-1.5-1-1.6-.9-3.5-1.4-5.4-1.6-1.9-.3-3.9-.4-5.8-.5q-1.6-.1-3.2,0-1.7,0-3.3.1-.3-1-.5-2-.2-1.1-.3-2.2-.2-1.5-.1-3q.2-1.5.5-3q.1-.3.1-.6.1-.2.2-.5q1.1-.1,2.4-.2q1.2-.1,2.6-.1c.9-.1,1.7-.1,2.6-.1.8,0,1.6,0,2.5.3q.9.4,1.7.9.9.4,1.8.9.9.7,1.8,1.6.9.8,1.7,1.7c1.1,1.3,2,2.8,2.6,4.4s1,3.3.9,5.1Z",
    fill: "url(#eNPyBg0c7kl146-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2501.6,683.2q.2.4,0,.9-.1.4-.6,1c-.6.6-1.1,1.3-1.8,1.9-.6.6-1.2,1.1-2,1.6-1.4.8-2.9,1.5-4.4,2-1.5.6-3,1-4.6,1.5-.7.2-1.4.4-2.2.6-.7.1-1.5.1-2.2,0-.6-.1-1.2-.3-1.8-.6s-1.1-.6-1.7-.9c-2.6-1.1-5.2-2.3-7.9-3.4-2.6-1.1-5.3-2.1-8-2.9-2.8-.8-5.6-1.4-8.4-1.7-2.9-.3-5.8-.3-8.6.1c4.4.1,8.9.9,13,2.4c4.2,1.4,8.2,3.5,11.7,6.2q.4.3.8.7t.5.8c.6,1.7-1.1,2.3-3.1,2.5-2.1.2-4.4,0-5.1-.2-1.7-.3-3.4-.8-5-1.4-1.7-.6-3.3-1.3-4.9-1.9-4.7-1.7-9.3-3.2-14.1-4.5-4.7-1.2-9.5-2.1-14.5-2.5.3,0,.8-.1,1.3-.3.4-.2.9-.5,1.2-.5q.8-.3,1.6-.5.9-.3,1.7-.5q1.6-.4,3.2-.8q1.6-.3,3.2-.6c3.6-.5,7.2-1,10.9-1.4c3.6-.3,7.2-.6,10.9-.6q-3.5-.8-7.1-1.1t-7.2-.3q-1.8.1-3.7.1-1.8.1-3.6.2-.5.1-.9.1-.5,0-1,0c-.2.1-.5.1-.8.2-.3,0-.6,0-.8,0-.4-.2-.4-.4-.2-.6s.6-.4.8-.5q.8-.5,1.6-.8.8-.4,1.6-.7q1.6-.7,3.3-1.1q1.7-.5,3.5-.9q1.9-.4,3.9-.7t4-.5c4.2-.5,8.2-.9,12.3-.9c4,0,8,.3,12.1,1.1q5.7,1.2,11.1,3.2q5.5,2,10.5,4.9.6.3,1,.6t.5.7Z",
    fill: "url(#eNPyBg0c7kl148-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2588.5,669c-3.3.7-5.7,1.6-7.8,2.7s-3.8,2.5-5.8,4.5c-2,1.9-3.7,4-5,6.4-1.2,2.4-2,5-2,7.7.2-1.2.9-2.4,1.8-3.6.8-1.2,1.7-2.3,2.4-3.3q1.2-1.7,2.4-3.1q1.3-1.5,2.6-3c1.7-1.9,3.4-3.5,5.3-4.8c1.8-1.4,3.8-2.5,6.1-3.5Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2434.4,794.6c-2.2.2-4-.2-5.7-1-1.6-.8-3.1-2-4.7-3.5c1-.1,1.6-.2,2.2-.4s1.1-.5,2.1-1c.5,1.1,1,1.9,1.5,2.6s1.2,1.3,2.2,2l1.2.7l1.2.6Z",
    fill: "url(#eNPyBg0c7kl150-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.047363 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2415.6,1407.2v102.7v102.7h3.5h3.6v-102.7-102.7h-3.6-3.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2469.3,1612.8h-50.1-50.2v-1.3-1.3h50.2h50.1v1.3v1.3Z",
    fill: "url(#eNPyBg0c7kl154-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2234.5,1392.2q1,1,2.1,1.9q1,.9,2.2,1.6c2.8,2.1,6.1,3.6,9.5,4.9c3.5,1.2,7.1,2.2,10.4,3.1q5.2,1.5,10.5,2.7t10.6,2.2q3.2.6,6.4,1.2q3.3.6,6.5,1.1c2,.4,4.1.8,6.1,1.2c2.1.3,4.1.6,6.2.5q6.7,0,13.5-.5q6.7-.5,13.4-1.2c8.4-.9,16.8-2.1,25.1-3.3c8.4-1.3,16.7-2.6,25.1-3.8c16.3-2.3,32.7-4.6,49-7c16.4-2.4,32.7-5,49-7.9c17-3,34.1-6.4,50.9-10.9c16.7-4.5,33.1-10.1,48.8-17.5c19.4-9.3,37.3-21.2,53.8-35c16.4-13.8,31.4-29.4,45-46c11-13.5,21.2-27.7,30.1-42.6c8.8-15,16.4-30.7,22-47.1c5.8-16.7,10.9-37.3,12.2-57.8c1.2-20.4-1.4-40.7-11.3-56.7-1.9-3.3-4.1-6.3-6.4-8.8-2.4-2.6-4.9-4.8-7.6-6.3-3.7-2.2-9.2-2.7-14.8-2.7s-11.4.5-15.8.5q-8.3-.1-16.5,0-8.3.1-16.6.4c-22.1.7-44.2,2.4-66.2,5-21.9,2.6-43.8,6.2-65.4,10.7-3.7.8-7.4,1.4-11,2.2s-7.2,1.7-10.8,3q-1,.4-2.1.8t-2.1.9c-1.6.7-3.2,1.5-4.6,2.4-1.5.9-2.8,2-3.8,3.3-.9,1.1-1.5,2.3-2,3.5s-1,2.5-1.3,3.8c-.6,2.5-.9,4.9-1.2,7.4-.2,2.4-.3,4.9-.4,7.3-1.3,32.2-6.1,64.8-15.7,95.7-9.6,30.8-23.9,60.1-44.4,85.6q-.7.8-1.3,1.5-.6.8-1.2,1.5c-11,13.2-23.8,25.1-37.9,35-14.1,10-29.5,18-45.6,23.7-11.8,4.1-24,6.9-36.3,8.2-12.4,1.3-24.8,1-37.2-.9-5.5-.9-11.4-1.9-17-1.8s-10.7,1.4-14.7,5.3c-3.9,4-5.2,9.4-4.5,14.9s3.4,10.9,7.3,14.8Z",
    fill: "url(#eNPyBg0c7kl155-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2234.5,1392.2q1,1,2.1,1.9q1,.9,2.2,1.6c8,5.9,18.7,9.6,29.6,12.2s22.1,4,31.2,5.3c11,1.6,22,2.8,33.1,3.7c11.1.8,22.2,1.4,33.2,1.6c55.9,1.1,114.6-5,169-22.2c54.3-17.1,104.4-45.4,143.3-88.6c20.2-22.7,36.8-48.7,48.6-76.7s18.9-57.9,20.1-88.3c.2-5.8.3-11.6-.1-17.4-.3-5.8-1-11.6-2.3-17.3-1-4.6-2.6-10.2-4.8-15.9-2.1-5.7-4.8-11.5-8.1-16.8q-1.6,4.6-3.2,9-1.6,4.5-3.1,8.9c-4.5,12.9-9.7,25.5-15.6,37.8s-12.5,24.3-19.7,35.9c-14.5,23-31.4,44.4-50.4,63.9-18.9,19.4-39.9,36.9-62.3,52.1-12.7,8.6-25.9,16.5-39.5,23.5-13.6,7.1-27.6,13.3-41.9,18.7-25.3,9.6-51.6,16.5-78.2,20.9-26.7,4.4-53.7,6.2-80.8,5.7-11.8,4.1-24,6.9-36.3,8.2-12.4,1.3-24.8,1-37.2-.9-5.5-.9-11.4-1.9-17-1.8s-10.7,1.4-14.7,5.3c-3.9,4-5.2,9.4-4.5,14.9s3.4,10.9,7.3,14.8Z",
    fill: "url(#eNPyBg0c7kl156-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2234.5,1392.2q1,1,2.1,1.9q1,.9,2.2,1.6c7.4,2.6,15.1,4.2,22.9,5c7.9.9,15.8,1.1,23.7.8c38.6-1.3,76.5-12.9,109.7-32.6s61.7-47.4,81.3-80.6c6.9-11.7,12.7-23.9,17.9-36.4c5.1-12.6,9.5-25.4,13.5-38.3c5.5-17.4,10.3-35.4,12.7-53.5c2.4-18,2.4-36.2-1.9-53.9-1.2-5.4-3.3-10.9-6.2-15.7-3-4.7-6.9-8.7-11.9-11.2q-1,.4-2.1.8t-2.1.9c-1.6.7-3.2,1.5-4.6,2.4-1.5.9-2.8,2-3.8,3.3-.9,1.1-1.5,2.3-2,3.5s-1,2.5-1.3,3.8c-.6,2.5-.9,4.9-1.2,7.4-.2,2.4-.3,4.9-.4,7.3-1.3,32.2-6.1,64.8-15.7,95.7-9.6,30.8-23.9,60.1-44.4,85.6q-.7.8-1.3,1.5-.6.8-1.2,1.5c-19,22.9-43.6,41.7-70.7,53.6-27.2,12-57,17-86.3,12.4-5.5-.9-11.4-1.9-17-1.8s-10.7,1.4-14.7,5.3c-3.9,4-5.2,9.4-4.5,14.9s3.4,10.9,7.3,14.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2527.8,1081.1c-.8.3-1.6.5-2.4.8-.7.4-1.5.8-2,1.4-1.5,1.6-1.6,3.7-.9,5.7.8,2.1,2.2,4.1,3.9,5.4c5.2,4.4,11.5,6.7,18.2,7.7s13.8.9,20.6.4q13.5-.9,26.9-2.8t26.6-4.9c7.7-1.7,17.3-3.3,26.6-5.7c9.3-2.3,18.3-5.5,24.7-10.3c9.7-7.3,5.9-11-1.4-12.9-7.4-1.9-18.2-2-22.4-2.1q-13.9-.1-27.9.9-13.9,1-27.7,3c-10.6,1.5-21.1,3.4-31.6,5.7s-20.8,4.9-31.2,7.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2367,1628.5c0,1.6.3,3.1.9,4.4.6,1.4,1.5,2.7,2.5,3.7s2.2,1.7,3.6,2.3c1.3.5,2.7.8,4.3.8c3.1,0,5.9-1.2,7.9-3.3c2.1-2,3.3-4.8,3.3-7.9c0-2.8-.9-5.3-2.6-7.2-1.6-2-3.8-3.4-6.4-3.9q-.5-.1-1.1-.2-.6,0-1.1,0c-3.1,0-6,1.3-8,3.3s-3.3,4.9-3.3,8Z",
    fill: "url(#eNPyBg0c7kl160-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2407.3,1628.5c0,1.6.4,3.1,1,4.5s1.4,2.6,2.5,3.6c1,1,2.2,1.8,3.5,2.3s2.8.8,4.3.8c3.1,0,5.9-1.2,8-3.3c2-2,3.3-4.8,3.3-7.9c0-2.8-1-5.2-2.6-7.2-1.6-1.9-3.8-3.3-6.4-3.9q0,0,0,0t0,0q-.6-.1-1.1-.2-.6,0-1.2,0c-3.1,0-5.9,1.3-8,3.3-2,2-3.3,4.9-3.3,8Z",
    fill: "url(#eNPyBg0c7kl161-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2446.8,1628.5c0,1.6.4,3.1,1,4.5s1.4,2.6,2.5,3.6c1,1,2.2,1.8,3.5,2.3s2.8.8,4.3.8c3.1,0,5.9-1.2,8-3.3c2-2,3.3-4.8,3.3-7.9c0-2.8-1-5.2-2.6-7.2-1.6-1.9-3.8-3.3-6.4-3.9q0,0,0,0t-.1,0q-.5-.1-1.1-.2-.5,0-1.1,0c-3.1,0-5.9,1.3-8,3.3-2,2-3.3,4.9-3.3,8Z",
    fill: "url(#eNPyBg0c7kl162-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2367,1628.5c0,1.6.3,3.1.9,4.4.6,1.4,1.5,2.7,2.5,3.7q.6.2,1.3.3.7,0,1.4,0c3.1,0,5.9-1.2,7.9-3.3c2.1-2,3.3-4.8,3.3-7.9c0-1.6-.3-3.2-1-4.6-.7-1.5-1.6-2.7-2.8-3.7q-.5-.1-1.1-.2-.6,0-1.1,0c-3.1,0-6,1.3-8,3.3s-3.3,4.9-3.3,8Z",
    fill: "url(#eNPyBg0c7kl164-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2407.3,1628.5c0,1.6.4,3.1,1,4.5s1.4,2.6,2.5,3.6q.6.2,1.3.3.6,0,1.3,0c3.1,0,5.9-1.2,8-3.3c2-2,3.3-4.8,3.3-7.9c0-1.6-.4-3.2-1.1-4.6-.6-1.4-1.5-2.7-2.7-3.7q0,0,0,0t0,0q-.6-.1-1.1-.2-.6,0-1.2,0c-3.1,0-5.9,1.3-8,3.3-2,2-3.3,4.9-3.3,8Z",
    fill: "url(#eNPyBg0c7kl165-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2446.8,1628.5c0,1.6.4,3.1,1,4.5s1.4,2.6,2.5,3.6q.6.2,1.3.3.6,0,1.3,0c3.1,0,5.9-1.2,8-3.3c2-2,3.3-4.8,3.3-7.9c0-1.6-.4-3.2-1.1-4.6-.6-1.4-1.5-2.7-2.7-3.7q0,0,0,0t-.1,0q-.5-.1-1.1-.2-.5,0-1.1,0c-3.1,0-5.9,1.3-8,3.3-2,2-3.3,4.9-3.3,8Z",
    fill: "url(#eNPyBg0c7kl166-fill)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact3);
export default __webpack_public_path__ + "static/media/contact3.1f266ae3410d173cc7ca884f93428410.svg";
export { ForwardRef as ReactComponent };